import { obj_type, float64_type, enum_type, list_type, bool_type, int32_type, union_type, option_type, record_type, string_type, class_type } from "./fable_modules/fable-library-js.4.24.0/Reflection.js";
import { toConsole, printf, toText, join } from "./fable_modules/fable-library-js.4.24.0/String.js";
import { toString as toString_1, Union, Record } from "./fable_modules/fable-library-js.4.24.0/Types.js";
import { datetime as datetime_1, list as list_5, nil, option as option_24, object, toString } from "./fable_modules/Thoth.Json.7.0.0/Encode.fs.js";
import { field, map as map_1, float, datetime, list as list_4, bool, fail, succeed, andThen, int, option as option_25, string, object as object_1 } from "./fable_modules/Thoth.Json.7.0.0/Decode.fs.js";
import { value as value_70, defaultArg } from "./fable_modules/fable-library-js.4.24.0/Option.js";
import { uncurry3, uncurry2 } from "./fable_modules/fable-library-js.4.24.0/Util.js";
import { Types_Full_get_Decoder, Types_Full_$reflection, Encoder_float, Types_ProbeKind_get_decode, Types_ProbeKind_$reflection, Encoder_int, Types_SensorKind_get_decode, Types_SensorKind_$reflection, Types_SensorOption, Types_SensorOption_$reflection, Types_DocKind_$reflection, Encoder_list, Encoder_empty, Encoder_string, Encoder_FieldCheck, Encoder_bool, Encoder_toPlainJsObj, Types_DocKind } from "../../iotpool-types/Project/Iotpool.Dotnet/fable/Library.fs.js";
import { toString as toString_2, minute, day as day_1, month, year, now } from "./fable_modules/fable-library-js.4.24.0/Date.js";
import { map } from "./fable_modules/fable-library-js.4.24.0/List.js";
import { parse } from "./fable_modules/fable-library-js.4.24.0/Double.js";

export const FrontVersionNumber = "2.4.5";

export const CurrentContract = "iotpool5";

export const DATA_WINDOW_HOURS = 24;

export class Log {
    constructor() {
    }
}

export function Log_$reflection() {
    return class_type("Shared.Log", undefined, Log);
}

function Api_builder(route) {
    return "/apiv2/" + route;
}

function Api_withParam(route, key) {
    return (Api_builder(route) + "/:") + key;
}

function Api_withParams(route, keys) {
    return (Api_builder(route) + "/:") + join("/:", keys);
}

export const Api_signin = Api_builder("auth/signin");

export const Api_forgetPassword = Api_builder("auth/forgetPassword");

export const Api_sendMagicLink = Api_builder("auth/sendMagicLink");

export const Api_checkMagicLink = Api_builder("auth/checkMagicLink");

export const Api_changePassword = Api_builder("auth/changePassword");

export const Api_updatePassword = Api_builder("auth/updatePassword");

export const Api_rollPassword = Api_builder("auth/rollPassword");

export const Api_signup = Api_builder("auth/signup");

export const Api_tags = Api_builder("tags");

export const Api_User_account = Api_builder("account");

export function Api_User_get(key) {
    return Api_withParam("user", key);
}

export const Api_User_me = Api_builder("me");

export const Api_User_monitoring = Api_builder("monitoring");

export const Api_Admin_User_add = Api_builder("admin/user");

export const Api_Admin_User_put = Api_builder("user");

export const Api_Ingress_put = Api_builder("sensor");

export const Api_Sensor_status = Api_builder("status");

export const Api_Sensor_list = Api_builder("sensors");

export function Api_Sensor_get(key) {
    return Api_withParam("sensor", key);
}

export const Api_Sensor_put = Api_builder("sensor");

export const Api_Sensor_toggleShare = Api_builder("toggleShare");

export const Api_Sensor_toggleShareView = Api_builder("toggleShareView");

export const Api_Sensor_toggleAlarmOff = Api_builder("toggleAlarmOff");

export function Api_Sensor_getData(keys) {
    return Api_withParams("data", keys);
}

export function Api_Sensor_getDataFromDateToDate(keys) {
    return Api_withParams("dataFromDateToDate", keys);
}

export function Api_Sensor_view(keys) {
    return Api_withParams("view", keys);
}

export function Api_Sensor_getProbes(keys) {
    return Api_withParams("probes", keys);
}

export function Api_Sensor_getBattery(key) {
    return Api_withParam("battery", key);
}

export function Api_Sensor_refreshPicture(key) {
    return Api_withParam("refreshPicture", key);
}

export const Api_Sensor_synchronize = Api_builder("synchronize");

export function Api_Shared_get(keys) {
    return Api_withParams("shared", keys);
}

function Api_Front_builder(route) {
    return "/apiv2/" + route;
}

function Api_Front_withParam(route, key) {
    return (Api_Front_builder(route) + "/") + key;
}

function Api_Front_withParams(route, keys) {
    return (Api_Front_builder(route) + "/") + join("/", keys);
}

export function Api_Front_getBattery(key) {
    return Api_Front_withParam("battery", key);
}

export function Api_Front_refreshPicture(key) {
    return Api_Front_withParam("refreshPicture", key);
}

export function Api_Front_getProbes(keys) {
    return Api_Front_withParams("probes", keys);
}

export function Api_Front_view(keys) {
    return Api_Front_withParams("view", keys);
}

export function Api_Front_getData(keys) {
    return Api_Front_withParams("data", keys);
}

export const Api_Front_synchronize = Api_Front_builder("synchronize");

export function Api_Front_getDataFromDateToDate(keys) {
    return Api_Front_withParams("dataFromDateToDate", keys);
}

export class AddSMS extends Record {
    constructor(SensorId) {
        super();
        this.SensorId = SensorId;
    }
}

export function AddSMS_$reflection() {
    return record_type("Shared.AddSMS", [], AddSMS, () => [["SensorId", string_type]]);
}

export function AddSMS_Encode_Z7B3EA352(o) {
    return toString(0, object([["sensorId", o.SensorId]]));
}

export function AddSMS_get_Decoder() {
    return (path_1) => ((v) => object_1((get$) => {
        let objectArg;
        return new AddSMS((objectArg = get$.Required, objectArg.Field("sensorId", string)));
    }, path_1, v));
}

export class MonitoringItem extends Record {
    constructor(UserId, SensorId, ProbeId) {
        super();
        this.UserId = UserId;
        this.SensorId = SensorId;
        this.ProbeId = ProbeId;
    }
}

export function MonitoringItem_$reflection() {
    return record_type("Shared.MonitoringItem", [], MonitoringItem, () => [["UserId", string_type], ["SensorId", string_type], ["ProbeId", string_type]]);
}

export function MonitoringItem_Encode_7FC334DB(o) {
    return toString(0, object([["userId", o.UserId], ["sensorId", o.SensorId], ["probeId", o.ProbeId]]));
}

export function MonitoringItem_get_Decoder() {
    return (path_3) => ((v) => object_1((get$) => {
        let objectArg, objectArg_1, objectArg_2;
        return new MonitoringItem((objectArg = get$.Required, objectArg.Field("userId", string)), (objectArg_1 = get$.Required, objectArg_1.Field("sensorId", string)), (objectArg_2 = get$.Required, objectArg_2.Field("probeId", string)));
    }, path_3, v));
}

export class GrantAccess extends Record {
    constructor(UserId, SensorId) {
        super();
        this.UserId = UserId;
        this.SensorId = SensorId;
    }
}

export function GrantAccess_$reflection() {
    return record_type("Shared.GrantAccess", [], GrantAccess, () => [["UserId", string_type], ["SensorId", string_type]]);
}

export function GrantAccess_Encode_Z339B0E98(o) {
    return toString(0, object([["userId", o.UserId], ["sensorId", o.SensorId]]));
}

export function GrantAccess_get_Decoder() {
    return (path_2) => ((v) => object_1((get$) => {
        let objectArg, objectArg_1;
        return new GrantAccess((objectArg = get$.Required, objectArg.Field("userId", string)), (objectArg_1 = get$.Required, objectArg_1.Field("sensorId", string)));
    }, path_2, v));
}

export class DuplicateAccess extends Record {
    constructor(FromId, ToId) {
        super();
        this.FromId = FromId;
        this.ToId = ToId;
    }
}

export function DuplicateAccess_$reflection() {
    return record_type("Shared.DuplicateAccess", [], DuplicateAccess, () => [["FromId", option_type(string_type)], ["ToId", option_type(string_type)]]);
}

export function DuplicateAccess_Encode_Z5B80E68F(o) {
    return toString(0, object([["from", option_24((value) => value)(o.FromId)], ["to", option_24((value_2) => value_2)(o.ToId)]]));
}

export function DuplicateAccess_get_Decoder() {
    return (path_4) => ((v) => object_1((get$) => {
        let objectArg, objectArg_1;
        return new DuplicateAccess(defaultArg((objectArg = get$.Optional, objectArg.Field("from", (path_1, value_1) => option_25(string, path_1, value_1))), undefined), defaultArg((objectArg_1 = get$.Optional, objectArg_1.Field("to", (path_3, value_4) => option_25(string, path_3, value_4))), undefined));
    }, path_4, v));
}

export class UserKey extends Record {
    constructor(Id, Rev, User, Sensor) {
        super();
        this.Id = Id;
        this.Rev = Rev;
        this.User = User;
        this.Sensor = Sensor;
    }
}

export function UserKey_$reflection() {
    return record_type("Shared.UserKey", [], UserKey, () => [["Id", string_type], ["Rev", option_type(string_type)], ["User", option_type(string_type)], ["Sensor", option_type(string_type)]]);
}

export function UserKey_get_Decoder() {
    return (path_7) => ((v) => object_1((get$) => {
        let objectArg, objectArg_1, objectArg_2, objectArg_3;
        return new UserKey((objectArg = get$.Required, objectArg.Field("_id", string)), defaultArg((objectArg_1 = get$.Optional, objectArg_1.Field("_rev", (path_2, value_2) => option_25(string, path_2, value_2))), undefined), defaultArg((objectArg_2 = get$.Optional, objectArg_2.Field("user", (path_4, value_5) => option_25(string, path_4, value_5))), undefined), defaultArg((objectArg_3 = get$.Optional, objectArg_3.Field("sensor", (path_6, value_8) => option_25(string, path_6, value_8))), undefined));
    }, path_7, v));
}

export class ErrorKind extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["UnknownUser", "WrongPassword"];
    }
}

export function ErrorKind_$reflection() {
    return union_type("Shared.ErrorKind", [], ErrorKind, () => [[], []]);
}

export class Error$ extends Record {
    constructor(Kind, Message) {
        super();
        this.Kind = Kind;
        this.Message = Message;
    }
}

export function Error$_$reflection() {
    return record_type("Shared.Error", [], Error$, () => [["Kind", ErrorKind_$reflection()], ["Message", string_type]]);
}

export class UpdateResponse extends Record {
    constructor(Rev, ShareKey) {
        super();
        this.Rev = Rev;
        this.ShareKey = ShareKey;
    }
}

export function UpdateResponse_$reflection() {
    return record_type("Shared.UpdateResponse", [], UpdateResponse, () => [["Rev", string_type], ["ShareKey", option_type(string_type)]]);
}

export function UpdateResponse_get_Decoder() {
    return (path_3) => ((v) => object_1((get$) => {
        let objectArg, objectArg_1;
        return new UpdateResponse((objectArg = get$.Required, objectArg.Field("rev", string)), defaultArg((objectArg_1 = get$.Optional, objectArg_1.Field("shareKey", (path_2, value_2) => option_25(string, path_2, value_2))), undefined));
    }, path_3, v));
}

export class ShareUpdateResponse extends Record {
    constructor(Rev, ShareCode, SharePass) {
        super();
        this.Rev = Rev;
        this.ShareCode = ShareCode;
        this.SharePass = SharePass;
    }
}

export function ShareUpdateResponse_$reflection() {
    return record_type("Shared.ShareUpdateResponse", [], ShareUpdateResponse, () => [["Rev", string_type], ["ShareCode", option_type(string_type)], ["SharePass", option_type(int32_type)]]);
}

export function ShareUpdateResponse_get_Decoder() {
    return (path_4) => ((v) => object_1((get$) => {
        let objectArg, objectArg_1, objectArg_2;
        return new ShareUpdateResponse((objectArg = get$.Required, objectArg.Field("rev", string)), defaultArg((objectArg_1 = get$.Optional, objectArg_1.Field("shareCode", (path_2, value_2) => option_25(string, path_2, value_2))), undefined), defaultArg((objectArg_2 = get$.Optional, objectArg_2.Field("sharePass", (path_3, value_4) => option_25(uncurry2(int), path_3, value_4))), undefined));
    }, path_4, v));
}

export class UserKind extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Admin", "Operator", "User"];
    }
}

export function UserKind_$reflection() {
    return union_type("Shared.UserKind", [], UserKind, () => [[], [], []]);
}

export const Helpers_decodeDocKind = (path_2) => ((value_1) => andThen(uncurry3((_arg) => {
    switch (_arg) {
        case "USER":
            return (arg10$0040) => ((arg20$0040) => succeed(new Types_DocKind(0, []), arg10$0040, arg20$0040));
        case "MODULE":
            return (arg10$0040_1) => ((arg20$0040_1) => succeed(new Types_DocKind(1, []), arg10$0040_1, arg20$0040_1));
        case "ACCOUNT":
            return (arg10$0040_2) => ((arg20$0040_2) => succeed(new Types_DocKind(2, []), arg10$0040_2, arg20$0040_2));
        case "TAG":
            return (arg10$0040_3) => ((arg20$0040_3) => succeed(new Types_DocKind(3, []), arg10$0040_3, arg20$0040_3));
        case "SENSOR":
            return (arg10$0040_4) => ((arg20$0040_4) => succeed(new Types_DocKind(4, []), arg10$0040_4, arg20$0040_4));
        case "CONTRACT":
            return (arg10$0040_5) => ((arg20$0040_5) => succeed(new Types_DocKind(5, []), arg10$0040_5, arg20$0040_5));
        case "ALARM":
            return (arg10$0040_6) => ((arg20$0040_6) => succeed(new Types_DocKind(6, []), arg10$0040_6, arg20$0040_6));
        case "ALARMSPACE":
            return (arg10$0040_7) => ((arg20$0040_7) => succeed(new Types_DocKind(7, []), arg10$0040_7, arg20$0040_7));
        default: {
            const msg = toText(printf("Failed to decode `%s` it\'s an invalid case for `DocKind`"))(_arg);
            return (path_1) => ((arg20$0040_8) => fail(msg, path_1, arg20$0040_8));
        }
    }
}), string, path_2, value_1));

export class Function_Fetch extends Record {
    constructor(Skey, Period) {
        super();
        this.Skey = Skey;
        this.Period = (Period | 0);
    }
}

export function Function_Fetch_$reflection() {
    return record_type("Shared.Function.Fetch", [], Function_Fetch, () => [["Skey", string_type], ["Period", int32_type]]);
}

export function Function_Fetch_get_Decoder() {
    return (path_1) => ((v) => object_1((get$) => {
        let objectArg, objectArg_1;
        return new Function_Fetch((objectArg = get$.Required, objectArg.Field("skey", string)), (objectArg_1 = get$.Required, objectArg_1.Field("period", uncurry2(int))));
    }, path_1, v));
}

export class ACL_AccessKind extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Read", "Write"];
    }
}

export function ACL_AccessKind_$reflection() {
    return union_type("Shared.ACL.AccessKind", [], ACL_AccessKind, () => [[["Item1", string_type], ["Item2", string_type]], [["Item1", string_type], ["Item2", string_type]]]);
}

export class ACL_Access extends Record {
    constructor(Id, Deleted, Rev) {
        super();
        this.Id = Id;
        this.Deleted = Deleted;
        this.Rev = Rev;
    }
}

export function ACL_Access_$reflection() {
    return record_type("Shared.ACL.Access", [], ACL_Access, () => [["Id", string_type], ["Deleted", option_type(bool_type)], ["Rev", option_type(string_type)]]);
}

export function ACL_Access_Encode_Z1E290B1A(o) {
    return Encoder_toPlainJsObj(Encoder_bool(new Encoder_FieldCheck(1, []), "_deleted", o.Deleted, Encoder_string(new Encoder_FieldCheck(1, []), "_rev", o.Rev, Encoder_string(new Encoder_FieldCheck(0, []), "_id", o.Id, Encoder_empty))));
}

export function ACL_Access_get_Decoder() {
    return (path_5) => ((v) => object_1((get$) => {
        let objectArg_1, objectArg_2;
        let Id;
        const objectArg = get$.Required;
        Id = objectArg.Field("_id", string);
        const Rev_1 = defaultArg((objectArg_1 = get$.Optional, objectArg_1.Field("_rev", (path_2, value_2) => option_25(string, path_2, value_2))), undefined);
        return new ACL_Access(Id, defaultArg((objectArg_2 = get$.Optional, objectArg_2.Field("_deleted", (path_4, value_5) => option_25(bool, path_4, value_5))), undefined), Rev_1);
    }, path_5, v));
}

export function ACL_Access_EncodeForCouch_Z1E290B1A(o) {
    const matchValue = o.Rev;
    const matchValue_1 = o.Deleted;
    let matchResult, rev, rev_1;
    if (matchValue == null) {
        matchResult = 2;
    }
    else if (matchValue_1 == null) {
        matchResult = 1;
        rev_1 = matchValue;
    }
    else if (matchValue_1) {
        matchResult = 0;
        rev = matchValue;
    }
    else {
        matchResult = 1;
        rev_1 = matchValue;
    }
    switch (matchResult) {
        case 0:
            return toString(0, object([["_id", o.Id], ["_rev", rev], ["_deleted", true]]));
        case 1:
            return toString(0, object([["_id", o.Id], ["_rev", rev_1]]));
        default:
            return toString(0, object([["_id", o.Id]]));
    }
}

export class Event_EventKind extends Union {
    constructor(Item) {
        super();
        this.tag = 0;
        this.fields = [Item];
    }
    cases() {
        return ["SMS"];
    }
}

export function Event_EventKind_$reflection() {
    return union_type("Shared.Event.EventKind", [], Event_EventKind, () => [[["Item", string_type]]]);
}

export class Event_Event extends Record {
    constructor(Id, Deleted, Rev) {
        super();
        this.Id = Id;
        this.Deleted = Deleted;
        this.Rev = Rev;
    }
}

export function Event_Event_$reflection() {
    return record_type("Shared.Event.Event", [], Event_Event, () => [["Id", string_type], ["Deleted", option_type(bool_type)], ["Rev", option_type(string_type)]]);
}

export function Event_Event_FromKind_124037C4(k) {
    const date = now();
    let date_1;
    const arg = year(date) | 0;
    const arg_1 = month(date) | 0;
    const arg_2 = day_1(date) | 0;
    const arg_3 = minute(date) | 0;
    date_1 = toText(printf("%i%i%i%i"))(arg)(arg_1)(arg_2)(arg_3);
    return new Event_Event(toText(printf("SMS_%s_%s"))(k.fields[0])(date_1), undefined, undefined);
}

export function Event_Event_Encode_Z7BDBB7B4(o) {
    return Encoder_toPlainJsObj(Encoder_bool(new Encoder_FieldCheck(1, []), "_deleted", o.Deleted, Encoder_string(new Encoder_FieldCheck(1, []), "_rev", o.Rev, Encoder_string(new Encoder_FieldCheck(0, []), "_id", o.Id, Encoder_empty))));
}

export function Event_Event_get_Decoder() {
    return (path_5) => ((v) => object_1((get$) => {
        let objectArg_1, objectArg_2;
        let Id;
        const objectArg = get$.Required;
        Id = objectArg.Field("_id", string);
        const Rev_1 = defaultArg((objectArg_1 = get$.Optional, objectArg_1.Field("_rev", (path_2, value_2) => option_25(string, path_2, value_2))), undefined);
        return new Event_Event(Id, defaultArg((objectArg_2 = get$.Optional, objectArg_2.Field("_deleted", (path_4, value_5) => option_25(bool, path_4, value_5))), undefined), Rev_1);
    }, path_5, v));
}

export function Event_Event_EncodeForCouch_Z7BDBB7B4(o) {
    const matchValue = o.Rev;
    const matchValue_1 = o.Deleted;
    let matchResult, rev, rev_1;
    if (matchValue == null) {
        matchResult = 2;
    }
    else if (matchValue_1 == null) {
        matchResult = 1;
        rev_1 = matchValue;
    }
    else if (matchValue_1) {
        matchResult = 0;
        rev = matchValue;
    }
    else {
        matchResult = 1;
        rev_1 = matchValue;
    }
    switch (matchResult) {
        case 0:
            return toString(0, object([["_id", o.Id], ["_rev", rev], ["_deleted", true]]));
        case 1:
            return toString(0, object([["_id", o.Id], ["_rev", rev_1]]));
        default:
            return toString(0, object([["_id", o.Id]]));
    }
}

export class ForgetPasswordCode extends Record {
    constructor(Id, UserId, Deleted, Rev) {
        super();
        this.Id = Id;
        this.UserId = UserId;
        this.Deleted = Deleted;
        this.Rev = Rev;
    }
}

export function ForgetPasswordCode_$reflection() {
    return record_type("Shared.ForgetPasswordCode", [], ForgetPasswordCode, () => [["Id", string_type], ["UserId", string_type], ["Deleted", option_type(bool_type)], ["Rev", option_type(string_type)]]);
}

export function ForgetPasswordCode_Encode_7140679D(o) {
    return Encoder_toPlainJsObj(Encoder_string(new Encoder_FieldCheck(0, []), "userId", o.UserId, Encoder_bool(new Encoder_FieldCheck(1, []), "_deleted", o.Deleted, Encoder_string(new Encoder_FieldCheck(1, []), "_rev", o.Rev, Encoder_string(new Encoder_FieldCheck(0, []), "_id", o.Id, Encoder_empty)))));
}

export function ForgetPasswordCode_Encoder_7140679D(o) {
    return object([["_id", o.Id], ["_rev", option_24((value_1) => value_1)(o.Rev)], ["_deleted", option_24((value_3) => value_3)(o.Deleted)], ["userId", o.UserId]]);
}

export function ForgetPasswordCode_get_Decoder() {
    return (path_6) => ((v) => object_1((get$) => {
        let objectArg_1, objectArg_2, objectArg_3;
        let Id;
        const objectArg = get$.Required;
        Id = objectArg.Field("_id", string);
        const Rev_1 = defaultArg((objectArg_1 = get$.Optional, objectArg_1.Field("_rev", (path_2, value_2) => option_25(string, path_2, value_2))), undefined);
        const Deleted = defaultArg((objectArg_2 = get$.Optional, objectArg_2.Field("_deleted", (path_4, value_5) => option_25(bool, path_4, value_5))), undefined);
        return new ForgetPasswordCode(Id, (objectArg_3 = get$.Required, objectArg_3.Field("userId", string)), Deleted, Rev_1);
    }, path_6, v));
}

export class Tag extends Record {
    constructor(Label, Sensors) {
        super();
        this.Label = Label;
        this.Sensors = Sensors;
    }
}

export function Tag_$reflection() {
    return record_type("Shared.Tag", [], Tag, () => [["Label", string_type], ["Sensors", list_type(string_type)]]);
}

export function Tag_get_Decoder() {
    return (path_3) => ((v) => object_1((get$) => {
        let objectArg, objectArg_1;
        return new Tag((objectArg = get$.Required, objectArg.Field("label", string)), (objectArg_1 = get$.Required, objectArg_1.Field("sensors", (path_2, value_2) => list_4(string, path_2, value_2))));
    }, path_3, v));
}

export function Tag_Encode_Z272CB4B0(o) {
    return Encoder_list(new Encoder_FieldCheck(0, []), "sensors", o.Sensors, undefined, Encoder_string(new Encoder_FieldCheck(0, []), "label", o.Label, Encoder_empty));
}

export function Tag_EncodePlain_Z272CB4B0(o) {
    return Encoder_toPlainJsObj(Encoder_list(new Encoder_FieldCheck(0, []), "sensors", o.Sensors, undefined, Encoder_string(new Encoder_FieldCheck(0, []), "label", o.Label, Encoder_empty)));
}

export class UserLight extends Record {
    constructor(Id, Email, Operator, Address1, Address2, City, Zip, Tel, Country, Company, Web, Color, Logo, Owner, UserKind, AppOptions, CustomPictures, Monitoring, ShareKey, Tags) {
        super();
        this.Id = Id;
        this.Email = Email;
        this.Operator = Operator;
        this.Address1 = Address1;
        this.Address2 = Address2;
        this.City = City;
        this.Zip = Zip;
        this.Tel = Tel;
        this.Country = Country;
        this.Company = Company;
        this.Web = Web;
        this.Color = Color;
        this.Logo = Logo;
        this.Owner = Owner;
        this.UserKind = UserKind;
        this.AppOptions = AppOptions;
        this.CustomPictures = CustomPictures;
        this.Monitoring = Monitoring;
        this.ShareKey = ShareKey;
        this.Tags = Tags;
    }
}

export function UserLight_$reflection() {
    return record_type("Shared.UserLight", [], UserLight, () => [["Id", string_type], ["Email", string_type], ["Operator", option_type(string_type)], ["Address1", option_type(string_type)], ["Address2", option_type(string_type)], ["City", option_type(string_type)], ["Zip", option_type(string_type)], ["Tel", option_type(string_type)], ["Country", option_type(string_type)], ["Company", option_type(string_type)], ["Web", option_type(string_type)], ["Color", option_type(string_type)], ["Logo", option_type(string_type)], ["Owner", option_type(string_type)], ["UserKind", UserKind_$reflection()], ["AppOptions", option_type(list_type(string_type))], ["CustomPictures", option_type(list_type(string_type))], ["Monitoring", option_type(list_type(string_type))], ["ShareKey", option_type(string_type)], ["Tags", option_type(list_type(Tag_$reflection()))]]);
}

export function UserLight_get_Decoder() {
    return (path_44) => ((v) => object_1((get$) => {
        let objectArg_3, objectArg_4, objectArg_5, objectArg_6, objectArg_7, objectArg_8, objectArg_9, objectArg_10, objectArg_11, objectArg_12, objectArg_13, objectArg_14, objectArg_15, objectArg_16, objectArg_17, objectArg_18, arg_42, decoder_22, decoder_21, objectArg_19;
        let Id;
        const objectArg = get$.Required;
        Id = objectArg.Field("id", string);
        let Email;
        const objectArg_1 = get$.Required;
        Email = objectArg_1.Field("email", string);
        let UserKind_1;
        const objectArg_2 = get$.Required;
        UserKind_1 = objectArg_2.Field("userKind", (path_5, value_3) => andThen(uncurry3((_arg_1) => {
            switch (_arg_1) {
                case "ADMIN":
                    return (arg10$0040_1) => ((arg20$0040_2) => succeed(new UserKind(0, []), arg10$0040_1, arg20$0040_2));
                case "OPERATOR":
                    return (arg10$0040_2) => ((arg20$0040_3) => succeed(new UserKind(1, []), arg10$0040_2, arg20$0040_3));
                case "USER":
                    return (arg10$0040_3) => ((arg20$0040_4) => succeed(new UserKind(2, []), arg10$0040_3, arg20$0040_4));
                default: {
                    const msg_1 = toText(printf("Failed to decode `%s` it\'s an invalid case for `UserKind`"))(_arg_1);
                    return (path_4) => ((arg20$0040_5) => fail(msg_1, path_4, arg20$0040_5));
                }
            }
        }), string, path_5, value_3));
        const Operator = defaultArg((objectArg_3 = get$.Optional, objectArg_3.Field("operator", (path_9, value_7) => option_25(string, path_9, value_7))), undefined);
        const Address = defaultArg((objectArg_4 = get$.Optional, objectArg_4.Field("address1", (path_11, value_10) => option_25(string, path_11, value_10))), undefined);
        const Address_1 = defaultArg((objectArg_5 = get$.Optional, objectArg_5.Field("address2", (path_13, value_13) => option_25(string, path_13, value_13))), undefined);
        const Zip = defaultArg((objectArg_6 = get$.Optional, objectArg_6.Field("zip", (path_15, value_16) => option_25(string, path_15, value_16))), undefined);
        const Tel = defaultArg((objectArg_7 = get$.Optional, objectArg_7.Field("tel", (path_17, value_19) => option_25(string, path_17, value_19))), undefined);
        const City = defaultArg((objectArg_8 = get$.Optional, objectArg_8.Field("city", (path_19, value_22) => option_25(string, path_19, value_22))), undefined);
        const Country = defaultArg((objectArg_9 = get$.Optional, objectArg_9.Field("country", (path_21, value_25) => option_25(string, path_21, value_25))), undefined);
        const Company = defaultArg((objectArg_10 = get$.Optional, objectArg_10.Field("company", (path_23, value_28) => option_25(string, path_23, value_28))), undefined);
        const Web = defaultArg((objectArg_11 = get$.Optional, objectArg_11.Field("web", (path_25, value_31) => option_25(string, path_25, value_31))), undefined);
        const Color = defaultArg((objectArg_12 = get$.Optional, objectArg_12.Field("color", (path_27, value_34) => option_25(string, path_27, value_34))), undefined);
        const Logo = defaultArg((objectArg_13 = get$.Optional, objectArg_13.Field("logo", (path_29, value_37) => option_25(string, path_29, value_37))), undefined);
        const Owner = defaultArg((objectArg_14 = get$.Optional, objectArg_14.Field("owner", (path_31, value_40) => option_25(string, path_31, value_40))), undefined);
        const ShareKey = defaultArg((objectArg_15 = get$.Optional, objectArg_15.Field("shareKey", (path_33, value_43) => option_25(string, path_33, value_43))), undefined);
        return new UserLight(Id, Email, Operator, Address, Address_1, City, Zip, Tel, Country, Company, Web, Color, Logo, Owner, UserKind_1, defaultArg((objectArg_16 = get$.Optional, objectArg_16.Field("appOptions", (path_35, value_46) => option_25((path_34, value_45) => list_4((path_2, value_1) => andThen(uncurry3((_arg) => {
            if (_arg === "ADDUSER") {
                return (arg10$0040) => ((arg20$0040) => succeed("ADDUSER", arg10$0040, arg20$0040));
            }
            else {
                const invalid = _arg;
                toConsole(printf("Failed to decode `%s` it\'s an invalid case for `AppOption`"))(invalid);
                const msg = toText(printf("Failed to decode `%s` it\'s an invalid case for `AppOption`"))(invalid);
                return (path_1) => ((arg20$0040_1) => fail(msg, path_1, arg20$0040_1));
            }
        }), string, path_2, value_1), path_34, value_45), path_35, value_46))), undefined), defaultArg((objectArg_17 = get$.Optional, objectArg_17.Field("customPictures", (path_38, value_50) => option_25((path_37, value_49) => list_4(string, path_37, value_49), path_38, value_50))), undefined), defaultArg((objectArg_18 = get$.Optional, objectArg_18.Field("monitoring", (path_41, value_54) => option_25((path_40, value_53) => list_4(string, path_40, value_53), path_41, value_54))), undefined), ShareKey, defaultArg((arg_42 = ((decoder_22 = ((decoder_21 = Tag_get_Decoder(), (path_42) => ((value_56) => list_4(uncurry2(decoder_21), path_42, value_56)))), (path_43) => ((value_57) => option_25(uncurry2(decoder_22), path_43, value_57)))), (objectArg_19 = get$.Optional, objectArg_19.Field("tags", uncurry2(arg_42)))), undefined));
    }, path_44, v));
}

export function UserLight_Encode_Z4D912D33(o) {
    const userKind = toString_1(o.UserKind).toUpperCase();
    let appOptions;
    const matchValue = o.AppOptions;
    appOptions = ((matchValue == null) ? nil : list_5(map((o_1) => o_1.toUpperCase(), matchValue)));
    let tags_1;
    const matchValue_1 = o.Tags;
    tags_1 = ((matchValue_1 == null) ? nil : list_5(map(Tag_EncodePlain_Z272CB4B0, matchValue_1)));
    let customPictures;
    const matchValue_2 = o.CustomPictures;
    customPictures = ((matchValue_2 == null) ? nil : list_5(map((value_2) => value_2, matchValue_2)));
    let monitoring;
    const matchValue_3 = o.Monitoring;
    monitoring = ((matchValue_3 == null) ? nil : list_5(map((value_4) => value_4, matchValue_3)));
    return object([["id", o.Id], ["email", o.Email], ["userKind", userKind], ["operator", option_24((value_9) => value_9)(o.Operator)], ["address1", option_24((value_11) => value_11)(o.Address1)], ["address2", option_24((value_13) => value_13)(o.Address2)], ["zip", option_24((value_15) => value_15)(o.Zip)], ["tel", option_24((value_17) => value_17)(o.Tel)], ["city", option_24((value_19) => value_19)(o.City)], ["country", option_24((value_21) => value_21)(o.Country)], ["company", option_24((value_23) => value_23)(o.Company)], ["web", option_24((value_25) => value_25)(o.Web)], ["color", option_24((value_27) => value_27)(o.Color)], ["logo", option_24((value_29) => value_29)(o.Logo)], ["owner", option_24((value_31) => value_31)(o.Owner)], ["shareKey", option_24((value_33) => value_33)(o.ShareKey)], ["appOptions", appOptions], ["customPictures", customPictures], ["monitoring", monitoring], ["tags", tags_1]]);
}

export function UserLight_get_Empty() {
    return new UserLight("", "", undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, new UserKind(2, []), undefined, undefined, undefined, undefined, undefined);
}

export class User extends Record {
    constructor(Id, DocKind, UserKind, Password, Email, Deleted, Rev, Operator, Address1, Address2, City, Zip, Tel, Country, Company, Web, Color, Logo, Owner, ShareKey, AppOptions, CustomPictures, Loraboxes, Monitoring, Tags) {
        super();
        this.Id = Id;
        this.DocKind = DocKind;
        this.UserKind = UserKind;
        this.Password = Password;
        this.Email = Email;
        this.Deleted = Deleted;
        this.Rev = Rev;
        this.Operator = Operator;
        this.Address1 = Address1;
        this.Address2 = Address2;
        this.City = City;
        this.Zip = Zip;
        this.Tel = Tel;
        this.Country = Country;
        this.Company = Company;
        this.Web = Web;
        this.Color = Color;
        this.Logo = Logo;
        this.Owner = Owner;
        this.ShareKey = ShareKey;
        this.AppOptions = AppOptions;
        this.CustomPictures = CustomPictures;
        this.Loraboxes = Loraboxes;
        this.Monitoring = Monitoring;
        this.Tags = Tags;
    }
}

export function User_$reflection() {
    return record_type("Shared.User", [], User, () => [["Id", string_type], ["DocKind", Types_DocKind_$reflection()], ["UserKind", UserKind_$reflection()], ["Password", string_type], ["Email", string_type], ["Deleted", option_type(bool_type)], ["Rev", option_type(string_type)], ["Operator", option_type(string_type)], ["Address1", option_type(string_type)], ["Address2", option_type(string_type)], ["City", option_type(string_type)], ["Zip", option_type(string_type)], ["Tel", option_type(string_type)], ["Country", option_type(string_type)], ["Company", option_type(string_type)], ["Web", option_type(string_type)], ["Color", option_type(string_type)], ["Logo", option_type(string_type)], ["Owner", option_type(string_type)], ["ShareKey", option_type(string_type)], ["AppOptions", option_type(list_type(string_type))], ["CustomPictures", option_type(list_type(string_type))], ["Loraboxes", option_type(list_type(string_type))], ["Monitoring", option_type(list_type(string_type))], ["Tags", option_type(list_type(Tag_$reflection()))]]);
}

export function User_toLight_ZCC4236D(o) {
    return new UserLight(o.Id, o.Email, o.Operator, o.Address1, o.Address2, o.City, o.Zip, o.Tel, o.Country, o.Company, o.Web, o.Color, o.Logo, o.Owner, o.UserKind, o.AppOptions, o.CustomPictures, o.Monitoring, o.ShareKey, o.Tags);
}

export function User_Encode_ZCC4236D(o) {
    let matchValue;
    const userKind = toString_1(o.UserKind).toUpperCase();
    const docKind = toString_1(o.DocKind).toUpperCase();
    return Encoder_toPlainJsObj(Encoder_list(new Encoder_FieldCheck(1, []), "tags", (matchValue = o.Tags, (matchValue == null) ? undefined : map(Tag_Encode_Z272CB4B0, matchValue)), undefined, Encoder_list(new Encoder_FieldCheck(1, []), "monitoring", o.Monitoring, undefined, Encoder_list(new Encoder_FieldCheck(1, []), "loraboxes", o.Loraboxes, undefined, Encoder_list(new Encoder_FieldCheck(1, []), "customPictures", o.CustomPictures, undefined, Encoder_list(new Encoder_FieldCheck(1, []), "appOptions", o.AppOptions, undefined, Encoder_string(new Encoder_FieldCheck(1, []), "shareKey", o.ShareKey, Encoder_string(new Encoder_FieldCheck(1, []), "owner", o.Owner, Encoder_string(new Encoder_FieldCheck(1, []), "logo", o.Logo, Encoder_string(new Encoder_FieldCheck(1, []), "color", o.Color, Encoder_string(new Encoder_FieldCheck(1, []), "web", o.Web, Encoder_string(new Encoder_FieldCheck(1, []), "company", o.Company, Encoder_string(new Encoder_FieldCheck(1, []), "country", o.Country, Encoder_string(new Encoder_FieldCheck(1, []), "tel", o.Tel, Encoder_string(new Encoder_FieldCheck(1, []), "zip", o.Zip, Encoder_string(new Encoder_FieldCheck(1, []), "address2", o.Address2, Encoder_string(new Encoder_FieldCheck(1, []), "address1", o.Address1, Encoder_string(new Encoder_FieldCheck(1, []), "operator", o.Operator, Encoder_string(new Encoder_FieldCheck(0, []), "userKind", userKind, Encoder_string(new Encoder_FieldCheck(0, []), "password", o.Password, Encoder_string(new Encoder_FieldCheck(0, []), "docKind", docKind, Encoder_string(new Encoder_FieldCheck(0, []), "email", o.Email, Encoder_bool(new Encoder_FieldCheck(1, []), "_deleted", o.Deleted, Encoder_string(new Encoder_FieldCheck(1, []), "_rev", o.Rev, Encoder_string(new Encoder_FieldCheck(0, []), "_id", o.Id, Encoder_empty)))))))))))))))))))))))));
}

export function User_get_Decoder() {
    return (path_52) => ((v) => object_1((get$) => {
        let objectArg_1, objectArg_2, objectArg_7, objectArg_8, objectArg_9, objectArg_10, objectArg_11, objectArg_12, objectArg_13, objectArg_14, objectArg_15, objectArg_16, objectArg_17, objectArg_18, objectArg_19, objectArg_20, objectArg_21, objectArg_22, objectArg_23, arg_51, decoder_26, decoder_25, objectArg_24;
        let Id;
        const objectArg = get$.Required;
        Id = objectArg.Field("_id", string);
        const Rev_1 = defaultArg((objectArg_1 = get$.Optional, objectArg_1.Field("_rev", (path_8, value_6) => option_25(string, path_8, value_6))), undefined);
        const Deleted = defaultArg((objectArg_2 = get$.Optional, objectArg_2.Field("_deleted", (path_10, value_9) => option_25(bool, path_10, value_9))), undefined);
        let Email;
        const objectArg_3 = get$.Required;
        Email = objectArg_3.Field("email", string);
        let DocKind;
        const objectArg_4 = get$.Required;
        DocKind = objectArg_4.Field("docKind", uncurry2(Helpers_decodeDocKind));
        let Password;
        const objectArg_5 = get$.Required;
        Password = objectArg_5.Field("password", string);
        let UserKind_1;
        const objectArg_6 = get$.Required;
        UserKind_1 = objectArg_6.Field("userKind", (path_5, value_3) => andThen(uncurry3((_arg_1) => {
            switch (_arg_1) {
                case "ADMIN":
                    return (arg10$0040_1) => ((arg20$0040_2) => succeed(new UserKind(0, []), arg10$0040_1, arg20$0040_2));
                case "OPERATOR":
                    return (arg10$0040_2) => ((arg20$0040_3) => succeed(new UserKind(1, []), arg10$0040_2, arg20$0040_3));
                case "USER":
                    return (arg10$0040_3) => ((arg20$0040_4) => succeed(new UserKind(2, []), arg10$0040_3, arg20$0040_4));
                default: {
                    const msg_1 = toText(printf("Failed to decode `%s` it\'s an invalid case for `UserKind`"))(_arg_1);
                    return (path_4) => ((arg20$0040_5) => fail(msg_1, path_4, arg20$0040_5));
                }
            }
        }), string, path_5, value_3));
        const Operator = defaultArg((objectArg_7 = get$.Optional, objectArg_7.Field("operator", (path_14, value_14) => option_25(string, path_14, value_14))), undefined);
        const Address = defaultArg((objectArg_8 = get$.Optional, objectArg_8.Field("address1", (path_16, value_17) => option_25(string, path_16, value_17))), undefined);
        const Address_1 = defaultArg((objectArg_9 = get$.Optional, objectArg_9.Field("address2", (path_18, value_20) => option_25(string, path_18, value_20))), undefined);
        const Zip = defaultArg((objectArg_10 = get$.Optional, objectArg_10.Field("zip", (path_20, value_23) => option_25(string, path_20, value_23))), undefined);
        const Tel = defaultArg((objectArg_11 = get$.Optional, objectArg_11.Field("tel", (path_22, value_26) => option_25(string, path_22, value_26))), undefined);
        return new User(Id, DocKind, UserKind_1, Password, Email, Deleted, Rev_1, Operator, Address, Address_1, defaultArg((objectArg_12 = get$.Optional, objectArg_12.Field("city", (path_24, value_29) => option_25(string, path_24, value_29))), undefined), Zip, Tel, defaultArg((objectArg_13 = get$.Optional, objectArg_13.Field("country", (path_26, value_32) => option_25(string, path_26, value_32))), undefined), defaultArg((objectArg_14 = get$.Optional, objectArg_14.Field("company", (path_28, value_35) => option_25(string, path_28, value_35))), undefined), defaultArg((objectArg_15 = get$.Optional, objectArg_15.Field("web", (path_30, value_38) => option_25(string, path_30, value_38))), undefined), defaultArg((objectArg_16 = get$.Optional, objectArg_16.Field("color", (path_32, value_41) => option_25(string, path_32, value_41))), undefined), defaultArg((objectArg_17 = get$.Optional, objectArg_17.Field("logo", (path_34, value_44) => option_25(string, path_34, value_44))), undefined), defaultArg((objectArg_18 = get$.Optional, objectArg_18.Field("owner", (path_36, value_47) => option_25(string, path_36, value_47))), undefined), defaultArg((objectArg_19 = get$.Optional, objectArg_19.Field("shareKey", (path_38, value_50) => option_25(string, path_38, value_50))), undefined), defaultArg((objectArg_20 = get$.Optional, objectArg_20.Field("appOptions", (path_40, value_53) => option_25((path_39, value_52) => list_4((path_2, value_1) => andThen(uncurry3((_arg) => {
            if (_arg === "ADDUSER") {
                return (arg10$0040) => ((arg20$0040) => succeed("ADDUSER", arg10$0040, arg20$0040));
            }
            else {
                const msg = toText(printf("Failed to decode `%s` it\'s an invalid case for `AppOption`"))(_arg);
                return (path_1) => ((arg20$0040_1) => fail(msg, path_1, arg20$0040_1));
            }
        }), string, path_2, value_1), path_39, value_52), path_40, value_53))), undefined), defaultArg((objectArg_21 = get$.Optional, objectArg_21.Field("customPictures", (path_43, value_57) => option_25((path_42, value_56) => list_4(string, path_42, value_56), path_43, value_57))), undefined), defaultArg((objectArg_22 = get$.Optional, objectArg_22.Field("loraboxes", (path_46, value_61) => option_25((path_45, value_60) => list_4(string, path_45, value_60), path_46, value_61))), undefined), defaultArg((objectArg_23 = get$.Optional, objectArg_23.Field("monitoring", (path_49, value_65) => option_25((path_48, value_64) => list_4(string, path_48, value_64), path_49, value_65))), undefined), defaultArg((arg_51 = ((decoder_26 = ((decoder_25 = Tag_get_Decoder(), (path_50) => ((value_67) => list_4(uncurry2(decoder_25), path_50, value_67)))), (path_51) => ((value_68) => option_25(uncurry2(decoder_26), path_51, value_68)))), (objectArg_24 = get$.Optional, objectArg_24.Field("tags", uncurry2(arg_51)))), undefined));
    }, path_52, v));
}

export function User_CreateFromCredentials_30230F9B(name, email, password) {
    let arg;
    return new User((arg = name.toLowerCase(), toText(printf("user_%s"))(arg)), new Types_DocKind(0, []), new UserKind(2, []), password, email, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
}

export function User_fromCredentials_Z384F8060(email, password) {
    return new User(toText(printf("user_%s"))(email), new Types_DocKind(0, []), new UserKind(2, []), password, email, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
}

export class UpdatePassword extends Record {
    constructor(Pass) {
        super();
        this.Pass = Pass;
    }
}

export function UpdatePassword_$reflection() {
    return record_type("Shared.UpdatePassword", [], UpdatePassword, () => [["Pass", string_type]]);
}

export function UpdatePassword_get_Decoder() {
    return (path_1) => ((v) => object_1((get$) => {
        let objectArg;
        return new UpdatePassword((objectArg = get$.Required, objectArg.Field("pass", string)));
    }, path_1, v));
}

export function UpdatePassword_Encode_Z547892B4(o) {
    return toString(0, object([["pass", o.Pass]]));
}

export class ForgetPassword extends Record {
    constructor(Email) {
        super();
        this.Email = Email;
    }
}

export function ForgetPassword_$reflection() {
    return record_type("Shared.ForgetPassword", [], ForgetPassword, () => [["Email", string_type]]);
}

export function ForgetPassword_get_Decoder() {
    return (path_1) => ((v) => object_1((get$) => {
        let arg, objectArg;
        return new ForgetPassword((arg = ((objectArg = get$.Required, objectArg.Field("email", string))), toText(printf("user_%s"))(arg)));
    }, path_1, v));
}

export function ForgetPassword_Encode_Z6C28E6B0(o) {
    return toString(0, object([["email", o.Email]]));
}

export class CheckMagicLink extends Record {
    constructor(MagicLink) {
        super();
        this.MagicLink = MagicLink;
    }
}

export function CheckMagicLink_$reflection() {
    return record_type("Shared.CheckMagicLink", [], CheckMagicLink, () => [["MagicLink", string_type]]);
}

export function CheckMagicLink_get_Decoder() {
    return (path_1) => ((v) => object_1((get$) => {
        let objectArg;
        return new CheckMagicLink((objectArg = get$.Required, objectArg.Field("magicLink", string)));
    }, path_1, v));
}

export function CheckMagicLink_Encode_4A222A5(o) {
    return toString(0, object([["magicLink", o.MagicLink]]));
}

export class Rev extends Record {
    constructor(Rev) {
        super();
        this.Rev = Rev;
    }
}

export function Rev_$reflection() {
    return record_type("Shared.Rev", [], Rev, () => [["Rev", string_type]]);
}

export function Rev_get_Decoder() {
    return (path_1) => ((v) => object_1((get$) => {
        let objectArg;
        return new Rev((objectArg = get$.Required, objectArg.Field("rev", string)));
    }, path_1, v));
}

export class OkResponse extends Record {
    constructor(Ok) {
        super();
        this.Ok = Ok;
    }
}

export function OkResponse_$reflection() {
    return record_type("Shared.OkResponse", [], OkResponse, () => [["Ok", bool_type]]);
}

export function OkResponse_get_Decoder() {
    return (path_1) => ((v) => object_1((get$) => {
        let objectArg;
        return new OkResponse((objectArg = get$.Required, objectArg.Field("ok", bool)));
    }, path_1, v));
}

export class MagicLink extends Record {
    constructor(Id, Deleted, Rev, Email) {
        super();
        this.Id = Id;
        this.Deleted = Deleted;
        this.Rev = Rev;
        this.Email = Email;
    }
}

export function MagicLink_$reflection() {
    return record_type("Shared.MagicLink", [], MagicLink, () => [["Id", string_type], ["Deleted", option_type(bool_type)], ["Rev", option_type(string_type)], ["Email", string_type]]);
}

export function MagicLink_get_Decoder() {
    return (path_6) => ((v) => object_1((get$) => {
        let objectArg_2, objectArg_3;
        let Email;
        const objectArg = get$.Required;
        Email = objectArg.Field("email", string);
        let Id;
        const objectArg_1 = get$.Required;
        Id = objectArg_1.Field("_id", string);
        const Rev_1 = defaultArg((objectArg_2 = get$.Optional, objectArg_2.Field("_rev", (path_3, value_3) => option_25(string, path_3, value_3))), undefined);
        return new MagicLink(Id, defaultArg((objectArg_3 = get$.Optional, objectArg_3.Field("_deleted", (path_5, value_6) => option_25(bool, path_5, value_6))), undefined), Rev_1, Email);
    }, path_6, v));
}

export function MagicLink_Encode_Z7EB35DFD(o) {
    return Encoder_toPlainJsObj(Encoder_bool(new Encoder_FieldCheck(1, []), "_deleted", o.Deleted, Encoder_string(new Encoder_FieldCheck(1, []), "_rev", o.Rev, Encoder_string(new Encoder_FieldCheck(0, []), "email", o.Email, Encoder_string(new Encoder_FieldCheck(0, []), "_id", o.Id, Encoder_empty)))));
}

export class ChangePassword extends Record {
    constructor(W1, W2, W3, Code) {
        super();
        this.W1 = W1;
        this.W2 = W2;
        this.W3 = W3;
        this.Code = Code;
    }
}

export function ChangePassword_$reflection() {
    return record_type("Shared.ChangePassword", [], ChangePassword, () => [["W1", string_type], ["W2", string_type], ["W3", string_type], ["Code", string_type]]);
}

export function ChangePassword_get_Decoder() {
    return (path_4) => ((v) => object_1((get$) => {
        let objectArg, objectArg_1, objectArg_2, objectArg_3;
        return new ChangePassword((objectArg = get$.Required, objectArg.Field("w1", string)), (objectArg_1 = get$.Required, objectArg_1.Field("w2", string)), (objectArg_2 = get$.Required, objectArg_2.Field("w3", string)), (objectArg_3 = get$.Required, objectArg_3.Field("code", string)));
    }, path_4, v));
}

export function ChangePassword_Encode_Z70BDEC65(o) {
    return toString(0, object([["w1", o.W1], ["w2", o.W2], ["w3", o.W3], ["code", o.Code]]));
}

export class Synchronize extends Record {
    constructor(Name, Sensors) {
        super();
        this.Name = Name;
        this.Sensors = Sensors;
    }
}

export function Synchronize_$reflection() {
    return record_type("Shared.Synchronize", [], Synchronize, () => [["Name", string_type], ["Sensors", list_type(string_type)]]);
}

export function Synchronize_get_Decoder() {
    return (path_3) => ((v) => object_1((get$) => {
        let objectArg, objectArg_1;
        return new Synchronize((objectArg = get$.Required, objectArg.Field("name", string)), (objectArg_1 = get$.Required, objectArg_1.Field("sensors", (path_2, value_2) => list_4(string, path_2, value_2))));
    }, path_3, v));
}

export function Synchronize_Encode_586435E8(o) {
    return toString(0, object([["name", o.Name], ["sensors", list_5(map((value_1) => value_1, o.Sensors))]]));
}

export class Signup extends Record {
    constructor(Email, Password) {
        super();
        this.Email = Email;
        this.Password = Password;
    }
}

export function Signup_$reflection() {
    return record_type("Shared.Signup", [], Signup, () => [["Email", string_type], ["Password", string_type]]);
}

export function Signup_get_Decoder() {
    return (path_2) => ((v) => object_1((get$) => {
        let arg, objectArg, objectArg_1;
        return new Signup((arg = ((objectArg = get$.Required, objectArg.Field("email", string))), toText(printf("user_%s"))(arg)), (objectArg_1 = get$.Required, objectArg_1.Field("password", string)));
    }, path_2, v));
}

export function Signup_Encode_Z51B8234C(o) {
    return toString(0, object([["email", o.Email], ["password", o.Password]]));
}

export class Auth_Response extends Record {
    constructor(Token, UserId, User) {
        super();
        this.Token = Token;
        this.UserId = UserId;
        this.User = User;
    }
}

export function Auth_Response_$reflection() {
    return record_type("Shared.Auth.Response", [], Auth_Response, () => [["Token", option_type(string_type)], ["UserId", option_type(string_type)], ["User", UserLight_$reflection()]]);
}

export function Auth_Response_Encode_Z881ED79(o) {
    return toString(0, object([["token", option_24((value) => value)(o.Token)], ["userId", option_24((value_2) => value_2)(o.UserId)], ["user", UserLight_Encode_Z4D912D33(o.User)]]));
}

export function Auth_Response_get_Decoder() {
    return (path_4) => ((v) => object_1((get$) => {
        let objectArg, objectArg_1, arg_5, objectArg_2;
        return new Auth_Response(defaultArg((objectArg = get$.Optional, objectArg.Field("token", (path_1, value_1) => option_25(string, path_1, value_1))), undefined), defaultArg((objectArg_1 = get$.Optional, objectArg_1.Field("userId", (path_3, value_4) => option_25(string, path_3, value_4))), undefined), (arg_5 = UserLight_get_Decoder(), (objectArg_2 = get$.Required, objectArg_2.Field("user", uncurry2(arg_5)))));
    }, path_4, v));
}

export class Auth_ForgetPasswordResponse extends Record {
    constructor(EmailSent) {
        super();
        this.EmailSent = EmailSent;
    }
}

export function Auth_ForgetPasswordResponse_$reflection() {
    return record_type("Shared.Auth.ForgetPasswordResponse", [], Auth_ForgetPasswordResponse, () => [["EmailSent", bool_type]]);
}

export function Auth_ForgetPasswordResponse_Encode_69286E35(o) {
    return toString(0, object([["emailSent", o.EmailSent]]));
}

export function Auth_ForgetPasswordResponse_get_Decoder() {
    return (path_1) => ((v) => object_1((get$) => {
        let objectArg;
        return new Auth_ForgetPasswordResponse((objectArg = get$.Required, objectArg.Field("emailSent", bool)));
    }, path_1, v));
}

export class Sensor_AddOption extends Record {
    constructor(SensorId, SensorOption) {
        super();
        this.SensorId = SensorId;
        this.SensorOption = SensorOption;
    }
}

export function Sensor_AddOption_$reflection() {
    return record_type("Shared.Sensor.AddOption", [], Sensor_AddOption, () => [["SensorId", string_type], ["SensorOption", Types_SensorOption_$reflection()]]);
}

export function Sensor_AddOption_Encode_3726B998(o) {
    return toString(0, object([["sensorId", o.SensorId], ["option", toString_1(o.SensorOption)]]));
}

export function Sensor_AddOption_get_Decoder() {
    return (path_4) => ((v) => object_1((get$) => {
        let objectArg, objectArg_1;
        return new Sensor_AddOption((objectArg = get$.Required, objectArg.Field("sensorId", string)), (objectArg_1 = get$.Required, objectArg_1.Field("option", (path_2, value_1) => andThen(uncurry3((_arg) => {
            switch (_arg) {
                case "ALARMSCHEDULER":
                    return (arg10$0040) => ((arg20$0040) => succeed(new Types_SensorOption(0, []), arg10$0040, arg20$0040));
                case "APISHARE":
                    return (arg10$0040_1) => ((arg20$0040_1) => succeed(new Types_SensorOption(1, []), arg10$0040_1, arg20$0040_1));
                case "SMS":
                    return (arg10$0040_2) => ((arg20$0040_2) => succeed(new Types_SensorOption(2, []), arg10$0040_2, arg20$0040_2));
                case "VOICE":
                    return (arg10$0040_3) => ((arg20$0040_3) => succeed(new Types_SensorOption(3, []), arg10$0040_3, arg20$0040_3));
                case "ALARMOFF":
                    return (arg10$0040_4) => ((arg20$0040_4) => succeed(new Types_SensorOption(4, []), arg10$0040_4, arg20$0040_4));
                default: {
                    const msg = toText(printf("Failed to decode `%s` it\'s an invalid case for `SensorOption`"))(_arg);
                    return (path_1) => ((arg20$0040_5) => fail(msg, path_1, arg20$0040_5));
                }
            }
        }), string, path_2, value_1))));
    }, path_4, v));
}

export class Sensor_APILink extends Record {
    constructor(Module, ModuleKey, UserKey) {
        super();
        this.Module = Module;
        this.ModuleKey = ModuleKey;
        this.UserKey = UserKey;
    }
}

export function Sensor_APILink_$reflection() {
    return record_type("Shared.Sensor.APILink", [], Sensor_APILink, () => [["Module", string_type], ["ModuleKey", string_type], ["UserKey", string_type]]);
}

export function Sensor_APILink_get_Decoder() {
    return (path_3) => ((v) => object_1((get$) => {
        let objectArg, objectArg_1, objectArg_2;
        return new Sensor_APILink((objectArg = get$.Required, objectArg.Field("module", string)), (objectArg_1 = get$.Required, objectArg_1.Field("moduleKey", string)), (objectArg_2 = get$.Required, objectArg_2.Field("userKey", string)));
    }, path_3, v));
}

export class Sensor_Status extends Record {
    constructor(Title, Name, LastCall, SensorKind, Date$, Tags) {
        super();
        this.Title = Title;
        this.Name = Name;
        this.LastCall = (LastCall | 0);
        this.SensorKind = SensorKind;
        this.Date = Date$;
        this.Tags = Tags;
    }
}

export function Sensor_Status_$reflection() {
    return record_type("Shared.Sensor.Status", [], Sensor_Status, () => [["Title", option_type(string_type)], ["Name", string_type], ["LastCall", int32_type], ["SensorKind", Types_SensorKind_$reflection()], ["Date", option_type(class_type("System.DateTime"))], ["Tags", option_type(string_type)]]);
}

export function Sensor_Status_get_Decoder() {
    return (path_7) => ((v) => object_1((get$) => {
        let objectArg, objectArg_3, arg_9, objectArg_4, objectArg_5;
        const Title = defaultArg((objectArg = get$.Optional, objectArg.Field("title", (path_1, value_1) => option_25(string, path_1, value_1))), undefined);
        let Name;
        const objectArg_1 = get$.Required;
        Name = objectArg_1.Field("name", string);
        let LastCall;
        const objectArg_2 = get$.Required;
        LastCall = objectArg_2.Field("lastCall", uncurry2(int));
        const Date$ = defaultArg((objectArg_3 = get$.Optional, objectArg_3.Field("date", (path_4, value_5) => option_25(datetime, path_4, value_5))), undefined);
        return new Sensor_Status(Title, Name, LastCall, (arg_9 = Types_SensorKind_get_decode(), (objectArg_4 = get$.Required, objectArg_4.Field("sensorKind", uncurry2(arg_9)))), Date$, defaultArg((objectArg_5 = get$.Optional, objectArg_5.Field("tags", (path_6, value_8) => option_25(string, path_6, value_8))), undefined));
    }, path_7, v));
}

export class Sensor_ScheduleDay extends Record {
    constructor(Hour, Day) {
        super();
        this.Hour = (Hour | 0);
        this.Day = (Day | 0);
    }
}

export function Sensor_ScheduleDay_$reflection() {
    return record_type("Shared.Sensor.ScheduleDay", [], Sensor_ScheduleDay, () => [["Hour", int32_type], ["Day", enum_type("System.DayOfWeek", int32_type, [["Sunday", 0], ["Monday", 1], ["Tuesday", 2], ["Wednesday", 3], ["Thursday", 4], ["Friday", 5], ["Saturday", 6]])]]);
}

export function Sensor_ScheduleDay_get_Decoder() {
    return (path_2) => ((v) => object_1((get$) => {
        let objectArg, objectArg_1;
        return new Sensor_ScheduleDay((objectArg = get$.Required, objectArg.Field("Hour", uncurry2(int))), (objectArg_1 = get$.Required, objectArg_1.Field("Day", (path_1, value) => andThen(uncurry3((_arg) => {
            switch (_arg) {
                case 0:
                    return (arg10$0040) => ((arg20$0040) => succeed(1, arg10$0040, arg20$0040));
                case 1:
                    return (arg10$0040_1) => ((arg20$0040_1) => succeed(2, arg10$0040_1, arg20$0040_1));
                case 2:
                    return (arg10$0040_2) => ((arg20$0040_2) => succeed(3, arg10$0040_2, arg20$0040_2));
                case 3:
                    return (arg10$0040_3) => ((arg20$0040_3) => succeed(4, arg10$0040_3, arg20$0040_3));
                case 4:
                    return (arg10$0040_4) => ((arg20$0040_4) => succeed(5, arg10$0040_4, arg20$0040_4));
                case 5:
                    return (arg10$0040_5) => ((arg20$0040_5) => succeed(6, arg10$0040_5, arg20$0040_5));
                case 6:
                    return (arg10$0040_6) => ((arg20$0040_6) => succeed(0, arg10$0040_6, arg20$0040_6));
                default: {
                    const msg = toText(printf("Failed to decode `%i` it\'s an invalid case for `Day`"))(_arg);
                    return (path) => ((arg20$0040_7) => fail(msg, path, arg20$0040_7));
                }
            }
        }), uncurry2(int), path_1, value))));
    }, path_2, v));
}

export function Sensor_ScheduleDay_EncodeForPouch_42302863(o) {
    let matchValue;
    return object([["Hour", o.Hour], ["Day", (matchValue = (o.Day | 0), (matchValue === 1) ? 0 : ((matchValue === 2) ? 1 : ((matchValue === 3) ? 2 : ((matchValue === 4) ? 3 : ((matchValue === 5) ? 4 : ((matchValue === 6) ? 5 : 6))))))]]);
}

export function Sensor_ScheduleDay_Encode_42302863(o) {
    let matchValue;
    return Encoder_toPlainJsObj(Encoder_int(new Encoder_FieldCheck(0, []), "Day", (matchValue = (o.Day | 0), (matchValue === 1) ? ((toConsole(printf("Monday")), 0)) : ((matchValue === 2) ? ((toConsole(printf("Tuesday")), 1)) : ((matchValue === 3) ? ((toConsole(printf("Wed")), 2)) : ((matchValue === 4) ? ((toConsole(printf("Thursday")), 3)) : ((matchValue === 5) ? ((toConsole(printf("Friday")), 4)) : ((matchValue === 6) ? ((toConsole(printf("Saturday")), 5)) : 6)))))), Encoder_int(new Encoder_FieldCheck(0, []), "Hour", o.Hour, Encoder_empty)));
}

export class Sensor_Light extends Record {
    constructor(Id, Name, S1, S2, S3, S4, S5, S6, S7, S8, S9, S10) {
        super();
        this.Id = Id;
        this.Name = Name;
        this.S1 = S1;
        this.S2 = S2;
        this.S3 = S3;
        this.S4 = S4;
        this.S5 = S5;
        this.S6 = S6;
        this.S7 = S7;
        this.S8 = S8;
        this.S9 = S9;
        this.S10 = S10;
    }
}

export function Sensor_Light_$reflection() {
    return record_type("Shared.Sensor.Light", [], Sensor_Light, () => [["Id", string_type], ["Name", string_type], ["S1", option_type(Types_ProbeKind_$reflection())], ["S2", option_type(Types_ProbeKind_$reflection())], ["S3", option_type(Types_ProbeKind_$reflection())], ["S4", option_type(Types_ProbeKind_$reflection())], ["S5", option_type(Types_ProbeKind_$reflection())], ["S6", option_type(Types_ProbeKind_$reflection())], ["S7", option_type(Types_ProbeKind_$reflection())], ["S8", option_type(Types_ProbeKind_$reflection())], ["S9", option_type(Types_ProbeKind_$reflection())], ["S10", option_type(Types_ProbeKind_$reflection())]]);
}

export function Sensor_Light_Encode_Z7EE950FC(o) {
    const probeKind = (sensor) => {
        if (sensor == null) {
            return undefined;
        }
        else {
            const s = value_70(sensor);
            return toString_1(s).toUpperCase();
        }
    };
    const s1 = probeKind(o.S1);
    const s2 = probeKind(o.S2);
    const s3 = probeKind(o.S3);
    const s4 = probeKind(o.S4);
    const s5 = probeKind(o.S5);
    const s6 = probeKind(o.S6);
    const s7 = probeKind(o.S7);
    const s8 = probeKind(o.S8);
    const s9 = probeKind(o.S9);
    return Encoder_toPlainJsObj(Encoder_string(new Encoder_FieldCheck(1, []), "s10", probeKind(o.S10), Encoder_string(new Encoder_FieldCheck(1, []), "s9", s9, Encoder_string(new Encoder_FieldCheck(1, []), "s8", s8, Encoder_string(new Encoder_FieldCheck(1, []), "s7", s7, Encoder_string(new Encoder_FieldCheck(1, []), "s6", s6, Encoder_string(new Encoder_FieldCheck(1, []), "s5", s5, Encoder_string(new Encoder_FieldCheck(1, []), "s4", s4, Encoder_string(new Encoder_FieldCheck(1, []), "s3", s3, Encoder_string(new Encoder_FieldCheck(1, []), "s2", s2, Encoder_string(new Encoder_FieldCheck(1, []), "s1", s1, Encoder_string(new Encoder_FieldCheck(0, []), "name", o.Name, Encoder_string(new Encoder_FieldCheck(0, []), "_id", o.Id, Encoder_empty)))))))))))));
}

export function Sensor_Light_get_Decoder() {
    return (path_12) => ((v) => object_1((get$) => {
        let objectArg, objectArg_1, arg_5, decoder, objectArg_2, arg_7, decoder_1, objectArg_3, arg_9, decoder_2, objectArg_4, arg_11, decoder_3, objectArg_5, arg_13, decoder_4, objectArg_6, arg_15, decoder_5, objectArg_7, arg_17, decoder_6, objectArg_8, arg_19, decoder_7, objectArg_9, arg_21, decoder_8, objectArg_10, arg_23, decoder_9, objectArg_11;
        return new Sensor_Light((objectArg = get$.Required, objectArg.Field("Id", string)), (objectArg_1 = get$.Required, objectArg_1.Field("Name", string)), defaultArg((arg_5 = ((decoder = Types_ProbeKind_get_decode(), (path_2) => ((value_2) => option_25(uncurry2(decoder), path_2, value_2)))), (objectArg_2 = get$.Optional, objectArg_2.Field("S1", uncurry2(arg_5)))), undefined), defaultArg((arg_7 = ((decoder_1 = Types_ProbeKind_get_decode(), (path_3) => ((value_4) => option_25(uncurry2(decoder_1), path_3, value_4)))), (objectArg_3 = get$.Optional, objectArg_3.Field("S2", uncurry2(arg_7)))), undefined), defaultArg((arg_9 = ((decoder_2 = Types_ProbeKind_get_decode(), (path_4) => ((value_6) => option_25(uncurry2(decoder_2), path_4, value_6)))), (objectArg_4 = get$.Optional, objectArg_4.Field("S3", uncurry2(arg_9)))), undefined), defaultArg((arg_11 = ((decoder_3 = Types_ProbeKind_get_decode(), (path_5) => ((value_8) => option_25(uncurry2(decoder_3), path_5, value_8)))), (objectArg_5 = get$.Optional, objectArg_5.Field("S4", uncurry2(arg_11)))), undefined), defaultArg((arg_13 = ((decoder_4 = Types_ProbeKind_get_decode(), (path_6) => ((value_10) => option_25(uncurry2(decoder_4), path_6, value_10)))), (objectArg_6 = get$.Optional, objectArg_6.Field("S5", uncurry2(arg_13)))), undefined), defaultArg((arg_15 = ((decoder_5 = Types_ProbeKind_get_decode(), (path_7) => ((value_12) => option_25(uncurry2(decoder_5), path_7, value_12)))), (objectArg_7 = get$.Optional, objectArg_7.Field("S6", uncurry2(arg_15)))), undefined), defaultArg((arg_17 = ((decoder_6 = Types_ProbeKind_get_decode(), (path_8) => ((value_14) => option_25(uncurry2(decoder_6), path_8, value_14)))), (objectArg_8 = get$.Optional, objectArg_8.Field("S7", uncurry2(arg_17)))), undefined), defaultArg((arg_19 = ((decoder_7 = Types_ProbeKind_get_decode(), (path_9) => ((value_16) => option_25(uncurry2(decoder_7), path_9, value_16)))), (objectArg_9 = get$.Optional, objectArg_9.Field("S8", uncurry2(arg_19)))), undefined), defaultArg((arg_21 = ((decoder_8 = Types_ProbeKind_get_decode(), (path_10) => ((value_18) => option_25(uncurry2(decoder_8), path_10, value_18)))), (objectArg_10 = get$.Optional, objectArg_10.Field("S9", uncurry2(arg_21)))), undefined), defaultArg((arg_23 = ((decoder_9 = Types_ProbeKind_get_decode(), (path_11) => ((value_20) => option_25(uncurry2(decoder_9), path_11, value_20)))), (objectArg_11 = get$.Optional, objectArg_11.Field("S10", uncurry2(arg_23)))), undefined));
    }, path_12, v));
}

export function Sensor_Light_FromFull_Z35750123(o) {
    return new Sensor_Light(o.Id, o.Name, o.S1, o.S2, o.S3, o.S4, o.S5, o.S6, o.S7, o.S8, o.S9, o.S10);
}

export class TagModule_Full extends Record {
    constructor(Id, Deleted, Rev, DocKind, Name, Sensors) {
        super();
        this.Id = Id;
        this.Deleted = Deleted;
        this.Rev = Rev;
        this.DocKind = DocKind;
        this.Name = Name;
        this.Sensors = Sensors;
    }
}

export function TagModule_Full_$reflection() {
    return record_type("Shared.TagModule.Full", [], TagModule_Full, () => [["Id", string_type], ["Deleted", option_type(bool_type)], ["Rev", option_type(string_type)], ["DocKind", Types_DocKind_$reflection()], ["Name", string_type], ["Sensors", list_type(string_type)]]);
}

export function TagModule_Full_Encode_26AC75D7(o) {
    return Encoder_toPlainJsObj(Encoder_list(new Encoder_FieldCheck(0, []), "sensors", o.Sensors, undefined, Encoder_string(new Encoder_FieldCheck(0, []), "name", o.Name, Encoder_string(new Encoder_FieldCheck(0, []), "docKind", toString_1(o.DocKind).toUpperCase(), Encoder_bool(new Encoder_FieldCheck(1, []), "_deleted", o.Deleted, Encoder_string(new Encoder_FieldCheck(1, []), "_rev", o.Rev, Encoder_string(new Encoder_FieldCheck(0, []), "_id", o.Id, Encoder_empty)))))));
}

export function TagModule_Full_get_Decoder() {
    return (path_8) => ((v) => object_1((get$) => {
        let objectArg_1, objectArg_2, objectArg_3, objectArg_4, objectArg_5;
        let Id;
        const objectArg = get$.Required;
        Id = objectArg.Field("_id", string);
        const Rev_1 = defaultArg((objectArg_1 = get$.Optional, objectArg_1.Field("_rev", (path_2, value_2) => option_25(string, path_2, value_2))), undefined);
        return new TagModule_Full(Id, defaultArg((objectArg_2 = get$.Optional, objectArg_2.Field("_deleted", (path_4, value_5) => option_25(bool, path_4, value_5))), undefined), Rev_1, (objectArg_3 = get$.Required, objectArg_3.Field("docKind", uncurry2(Helpers_decodeDocKind))), (objectArg_4 = get$.Required, objectArg_4.Field("name", string)), (objectArg_5 = get$.Required, objectArg_5.Field("sensors", (path_7, value_9) => list_4(string, path_7, value_9))));
    }, path_8, v));
}

export class TagModule_Light extends Record {
    constructor(Name, Sensors) {
        super();
        this.Name = Name;
        this.Sensors = Sensors;
    }
}

export function TagModule_Light_$reflection() {
    return record_type("Shared.TagModule.Light", [], TagModule_Light, () => [["Name", string_type], ["Sensors", list_type(string_type)]]);
}

export function TagModule_Light_FromFull_26AC75D7(o) {
    return new TagModule_Light(o.Name, o.Sensors);
}

export class WarpValue extends Record {
    constructor(Type, Label) {
        super();
        this.Type = Type;
        this.Label = Label;
    }
}

export function WarpValue_$reflection() {
    return record_type("Shared.WarpValue", [], WarpValue, () => [["Type", string_type], ["Label", option_type(string_type)]]);
}

export function WarpValue_get_Decoder() {
    return (path_3) => ((v) => object_1((get$) => {
        let objectArg, objectArg_1;
        return new WarpValue((objectArg = get$.Required, objectArg.Field("type", string)), defaultArg((objectArg_1 = get$.Optional, objectArg_1.Field("label", (path_2, value_2) => option_25(string, path_2, value_2))), undefined));
    }, path_3, v));
}

export class WarpValueDescription extends Record {
    constructor(Battery, S1, S2, S3, S4, S5, S6, S7, S8, S9, S10, Cumulated) {
        super();
        this.Battery = Battery;
        this.S1 = S1;
        this.S2 = S2;
        this.S3 = S3;
        this.S4 = S4;
        this.S5 = S5;
        this.S6 = S6;
        this.S7 = S7;
        this.S8 = S8;
        this.S9 = S9;
        this.S10 = S10;
        this.Cumulated = Cumulated;
    }
}

export function WarpValueDescription_$reflection() {
    return record_type("Shared.WarpValueDescription", [], WarpValueDescription, () => [["Battery", option_type(WarpValue_$reflection())], ["S1", option_type(WarpValue_$reflection())], ["S2", option_type(WarpValue_$reflection())], ["S3", option_type(WarpValue_$reflection())], ["S4", option_type(WarpValue_$reflection())], ["S5", option_type(WarpValue_$reflection())], ["S6", option_type(WarpValue_$reflection())], ["S7", option_type(WarpValue_$reflection())], ["S8", option_type(WarpValue_$reflection())], ["S9", option_type(WarpValue_$reflection())], ["S10", option_type(WarpValue_$reflection())], ["Cumulated", option_type(WarpValue_$reflection())]]);
}

export function WarpValueDescription_get_Decoder() {
    return (path_12) => ((v) => object_1((get$) => {
        let arg_1, decoder, objectArg, arg_3, decoder_1, objectArg_1, arg_5, decoder_2, objectArg_2, arg_7, decoder_3, objectArg_3, arg_9, decoder_4, objectArg_4, arg_11, decoder_5, objectArg_5, arg_13, decoder_6, objectArg_6, arg_15, decoder_7, objectArg_7, arg_17, decoder_8, objectArg_8, arg_19, decoder_9, objectArg_9, arg_21, decoder_10, objectArg_10, arg_23, decoder_11, objectArg_11;
        return new WarpValueDescription(defaultArg((arg_1 = ((decoder = WarpValue_get_Decoder(), (path) => ((value) => option_25(uncurry2(decoder), path, value)))), (objectArg = get$.Optional, objectArg.Field("battery", uncurry2(arg_1)))), undefined), defaultArg((arg_3 = ((decoder_1 = WarpValue_get_Decoder(), (path_1) => ((value_2) => option_25(uncurry2(decoder_1), path_1, value_2)))), (objectArg_1 = get$.Optional, objectArg_1.Field("s1", uncurry2(arg_3)))), undefined), defaultArg((arg_5 = ((decoder_2 = WarpValue_get_Decoder(), (path_2) => ((value_4) => option_25(uncurry2(decoder_2), path_2, value_4)))), (objectArg_2 = get$.Optional, objectArg_2.Field("s2", uncurry2(arg_5)))), undefined), defaultArg((arg_7 = ((decoder_3 = WarpValue_get_Decoder(), (path_3) => ((value_6) => option_25(uncurry2(decoder_3), path_3, value_6)))), (objectArg_3 = get$.Optional, objectArg_3.Field("s3", uncurry2(arg_7)))), undefined), defaultArg((arg_9 = ((decoder_4 = WarpValue_get_Decoder(), (path_4) => ((value_8) => option_25(uncurry2(decoder_4), path_4, value_8)))), (objectArg_4 = get$.Optional, objectArg_4.Field("s4", uncurry2(arg_9)))), undefined), defaultArg((arg_11 = ((decoder_5 = WarpValue_get_Decoder(), (path_5) => ((value_10) => option_25(uncurry2(decoder_5), path_5, value_10)))), (objectArg_5 = get$.Optional, objectArg_5.Field("s5", uncurry2(arg_11)))), undefined), defaultArg((arg_13 = ((decoder_6 = WarpValue_get_Decoder(), (path_6) => ((value_12) => option_25(uncurry2(decoder_6), path_6, value_12)))), (objectArg_6 = get$.Optional, objectArg_6.Field("s6", uncurry2(arg_13)))), undefined), defaultArg((arg_15 = ((decoder_7 = WarpValue_get_Decoder(), (path_7) => ((value_14) => option_25(uncurry2(decoder_7), path_7, value_14)))), (objectArg_7 = get$.Optional, objectArg_7.Field("s7", uncurry2(arg_15)))), undefined), defaultArg((arg_17 = ((decoder_8 = WarpValue_get_Decoder(), (path_8) => ((value_16) => option_25(uncurry2(decoder_8), path_8, value_16)))), (objectArg_8 = get$.Optional, objectArg_8.Field("s8", uncurry2(arg_17)))), undefined), defaultArg((arg_19 = ((decoder_9 = WarpValue_get_Decoder(), (path_9) => ((value_18) => option_25(uncurry2(decoder_9), path_9, value_18)))), (objectArg_9 = get$.Optional, objectArg_9.Field("s9", uncurry2(arg_19)))), undefined), defaultArg((arg_21 = ((decoder_10 = WarpValue_get_Decoder(), (path_10) => ((value_20) => option_25(uncurry2(decoder_10), path_10, value_20)))), (objectArg_10 = get$.Optional, objectArg_10.Field("s10", uncurry2(arg_21)))), undefined), defaultArg((arg_23 = ((decoder_11 = WarpValue_get_Decoder(), (path_11) => ((value_22) => option_25(uncurry2(decoder_11), path_11, value_22)))), (objectArg_11 = get$.Optional, objectArg_11.Field("cumulated", uncurry2(arg_23)))), undefined));
    }, path_12, v));
}

export class WarpResult extends Record {
    constructor(Epoch, Battery, S1, S2, S3, S4, S5, S6, S7, S8, S9, S10, Cumulated) {
        super();
        this.Epoch = Epoch;
        this.Battery = Battery;
        this.S1 = S1;
        this.S2 = S2;
        this.S3 = S3;
        this.S4 = S4;
        this.S5 = S5;
        this.S6 = S6;
        this.S7 = S7;
        this.S8 = S8;
        this.S9 = S9;
        this.S10 = S10;
        this.Cumulated = Cumulated;
    }
}

export function WarpResult_$reflection() {
    return record_type("Shared.WarpResult", [], WarpResult, () => [["Epoch", float64_type], ["Battery", option_type(float64_type)], ["S1", option_type(float64_type)], ["S2", option_type(float64_type)], ["S3", option_type(float64_type)], ["S4", option_type(float64_type)], ["S5", option_type(float64_type)], ["S6", option_type(float64_type)], ["S7", option_type(float64_type)], ["S8", option_type(float64_type)], ["S9", option_type(float64_type)], ["S10", option_type(float64_type)], ["Cumulated", option_type(float64_type)]]);
}

export function WarpResult_get_Decoder() {
    return (path_25) => ((v) => object_1((get$) => {
        let objectArg, objectArg_1, objectArg_2, objectArg_3, objectArg_4, objectArg_5, objectArg_6, objectArg_7, objectArg_8, objectArg_9, objectArg_10, objectArg_11, objectArg_12;
        return new WarpResult((objectArg = get$.Required, objectArg.Field("epoch", float)), defaultArg((objectArg_1 = get$.Optional, objectArg_1.Field("battery", (path_2, value_2) => option_25(float, path_2, value_2))), undefined), defaultArg((objectArg_2 = get$.Optional, objectArg_2.Field("s1", (path_4, value_5) => option_25(float, path_4, value_5))), undefined), defaultArg((objectArg_3 = get$.Optional, objectArg_3.Field("s2", (path_6, value_8) => option_25(float, path_6, value_8))), undefined), defaultArg((objectArg_4 = get$.Optional, objectArg_4.Field("s3", (path_8, value_11) => option_25(float, path_8, value_11))), undefined), defaultArg((objectArg_5 = get$.Optional, objectArg_5.Field("s4", (path_10, value_14) => option_25(float, path_10, value_14))), undefined), defaultArg((objectArg_6 = get$.Optional, objectArg_6.Field("s5", (path_12, value_17) => option_25(float, path_12, value_17))), undefined), defaultArg((objectArg_7 = get$.Optional, objectArg_7.Field("s6", (path_14, value_20) => option_25(float, path_14, value_20))), undefined), defaultArg((objectArg_8 = get$.Optional, objectArg_8.Field("s7", (path_16, value_23) => option_25(float, path_16, value_23))), undefined), defaultArg((objectArg_9 = get$.Optional, objectArg_9.Field("s8", (path_18, value_26) => option_25(float, path_18, value_26))), undefined), defaultArg((objectArg_10 = get$.Optional, objectArg_10.Field("s9", (path_20, value_29) => option_25(float, path_20, value_29))), undefined), defaultArg((objectArg_11 = get$.Optional, objectArg_11.Field("s10", (path_22, value_32) => option_25(float, path_22, value_32))), undefined), defaultArg((objectArg_12 = get$.Optional, objectArg_12.Field("cumulated", (path_24, value_35) => option_25(float, path_24, value_35))), undefined));
    }, path_25, v));
}

export class NextWarpValues extends Record {
    constructor(Name, Sensors, Data) {
        super();
        this.Name = Name;
        this.Sensors = Sensors;
        this.Data = Data;
    }
}

export function NextWarpValues_$reflection() {
    return record_type("Shared.NextWarpValues", [], NextWarpValues, () => [["Name", string_type], ["Sensors", WarpValueDescription_$reflection()], ["Data", list_type(WarpResult_$reflection())]]);
}

export function NextWarpValues_get_Decoder() {
    return (path_2) => ((v) => object_1((get$) => {
        let objectArg, arg_3, objectArg_1, arg_5, decoder, objectArg_2;
        return new NextWarpValues((objectArg = get$.Required, objectArg.Field("name", string)), (arg_3 = WarpValueDescription_get_Decoder(), (objectArg_1 = get$.Required, objectArg_1.Field("sensors", uncurry2(arg_3)))), (arg_5 = ((decoder = WarpResult_get_Decoder(), (path_1) => ((value_1) => list_4(uncurry2(decoder), path_1, value_1)))), (objectArg_2 = get$.Required, objectArg_2.Field("data", uncurry2(arg_5)))));
    }, path_2, v));
}

export class SensorValueKind extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Float", "String", "Int"];
    }
}

export function SensorValueKind_$reflection() {
    return union_type("Shared.SensorValueKind", [], SensorValueKind, () => [[["value", float64_type]], [["value", string_type]], [["value", int32_type]]]);
}

export class SensorValue extends Record {
    constructor(Date$, Value, Id) {
        super();
        this.Date = Date$;
        this.Value = Value;
        this.Id = Id;
    }
}

export function SensorValue_$reflection() {
    return record_type("Shared.SensorValue", [], SensorValue, () => [["Date", class_type("System.DateTime")], ["Value", SensorValueKind_$reflection()], ["Id", string_type]]);
}

export function SensorValue_Encode_7932F7DF(o) {
    const date = toString_2(o.Date, "O", {});
    const matchValue = o.Value;
    switch (matchValue.tag) {
        case 2:
            return object([["date", date], ["kind", "INT"], ["value", matchValue.fields[0]], ["id", o.Id]]);
        case 1:
            return object([["date", date], ["kind", "STRING"], ["value", matchValue.fields[0]], ["id", o.Id]]);
        default:
            return object([["date", date], ["kind", "FLOAT"], ["value", parse(toText(printf("%0.2f"))(matchValue.fields[0]))], ["id", o.Id]]);
    }
}

export function SensorValue_Encoder_7932F7DF(o) {
    const date = toString_2(o.Date, "O", {});
    const matchValue = o.Value;
    switch (matchValue.tag) {
        case 1:
            return Encoder_toPlainJsObj(Encoder_string(new Encoder_FieldCheck(0, []), "id", o.Id, Encoder_string(new Encoder_FieldCheck(0, []), "value", matchValue.fields[0], Encoder_string(new Encoder_FieldCheck(0, []), "kind", "STRING", Encoder_string(new Encoder_FieldCheck(0, []), "date", date, Encoder_empty)))));
        case 2:
            return Encoder_toPlainJsObj(Encoder_string(new Encoder_FieldCheck(0, []), "id", o.Id, Encoder_int(new Encoder_FieldCheck(0, []), "value", matchValue.fields[0], Encoder_string(new Encoder_FieldCheck(0, []), "kind", "INT", Encoder_string(new Encoder_FieldCheck(0, []), "date", date, Encoder_empty)))));
        default:
            return Encoder_toPlainJsObj(Encoder_string(new Encoder_FieldCheck(0, []), "id", o.Id, Encoder_float(new Encoder_FieldCheck(0, []), "value", matchValue.fields[0], Encoder_string(new Encoder_FieldCheck(0, []), "kind", "FLOAT", Encoder_string(new Encoder_FieldCheck(0, []), "date", date, Encoder_empty)))));
    }
}

export function SensorValue_get_Decoder() {
    return (path_14) => ((v) => object_1((get$) => {
        let objectArg, objectArg_1;
        return new SensorValue((objectArg = get$.Required, objectArg.Field("date", datetime)), get$.Required.Raw((path_11, value_13) => andThen(uncurry3((_arg) => {
            switch (_arg) {
                case "FLOAT":
                    return (path_4) => ((value_5) => map_1((value_4) => (new SensorValueKind(0, [value_4])), (path_3, value_3) => field("value", float, path_3, value_3), path_4, value_5));
                case "STRING":
                    return (path_7) => ((value_9) => map_1((value_8) => (new SensorValueKind(1, [value_8])), (path_6, value_7) => field("value", string, path_6, value_7), path_7, value_9));
                case "INT":
                    return (path_9) => ((value_12) => map_1((value_11) => (new SensorValueKind(2, [value_11])), (path_8, value_10) => field("value", uncurry2(int), path_8, value_10), path_9, value_12));
                default: {
                    const msg = toText(printf("Unknown shape type %s"))(_arg);
                    return (path_10) => ((arg20$0040) => fail(msg, path_10, arg20$0040));
                }
            }
        }), (path_1, value_1) => field("kind", string, path_1, value_1), path_11, value_13)), (objectArg_1 = get$.Required, objectArg_1.Field("id", string)));
    }, path_14, v));
}

export function SensorValue_get_WarpDecoder() {
    return (path_3) => ((v) => object_1((get$) => {
        let objectArg, objectArg_1, objectArg_2;
        return new SensorValue((objectArg = get$.Required, objectArg.Field("date", datetime)), new SensorValueKind(0, [(objectArg_1 = get$.Required, objectArg_1.Field("value", float))]), (objectArg_2 = get$.Required, objectArg_2.Field("id", string)));
    }, path_3, v));
}

export class DataList extends Record {
    constructor(List, Name) {
        super();
        this.List = List;
        this.Name = Name;
    }
}

export function DataList_$reflection() {
    return record_type("Shared.DataList", [], DataList, () => [["List", list_type(SensorValue_$reflection())], ["Name", string_type]]);
}

export function DataList_get_Decoder() {
    return (path_2) => ((v) => object_1((get$) => {
        let arg_3, decoder, objectArg_1;
        let Name;
        const objectArg = get$.Required;
        Name = objectArg.Field("name", string);
        return new DataList((arg_3 = ((decoder = SensorValue_get_WarpDecoder(), (path_1) => ((value_1) => list_4(uncurry2(decoder), path_1, value_1)))), (objectArg_1 = get$.Required, objectArg_1.Field("list", uncurry2(arg_3)))), Name);
    }, path_2, v));
}

export class Data extends Record {
    constructor(Sensors, Users) {
        super();
        this.Sensors = Sensors;
        this.Users = Users;
    }
}

export function Data_$reflection() {
    return record_type("Shared.Data", [], Data, () => [["Sensors", list_type(Types_Full_$reflection())], ["Users", list_type(User_$reflection())]]);
}

export function Data_get_Decoder() {
    return (path_2) => ((v) => object_1((get$) => {
        let arg_1, decoder, objectArg, arg_3, decoder_1, objectArg_1;
        return new Data((arg_1 = ((decoder = Types_Full_get_Decoder(), (path) => ((value) => list_4(uncurry2(decoder), path, value)))), (objectArg = get$.Required, objectArg.Field("sensors", uncurry2(arg_1)))), (arg_3 = ((decoder_1 = User_get_Decoder(), (path_1) => ((value_1) => list_4(uncurry2(decoder_1), path_1, value_1)))), (objectArg_1 = get$.Required, objectArg_1.Field("users", uncurry2(arg_3)))));
    }, path_2, v));
}

export class DataListSequence extends Record {
    constructor(Docs) {
        super();
        this.Docs = Docs;
    }
}

export function DataListSequence_$reflection() {
    return record_type("Shared.DataListSequence", [], DataListSequence, () => [["Docs", list_type(DataList_$reflection())]]);
}

export function DataListSequence_get_Decoder() {
    return (path_1) => ((v) => object_1((get$) => {
        let arg_1, decoder, objectArg;
        return new DataListSequence((arg_1 = ((decoder = DataList_get_Decoder(), (path) => ((value) => list_4(uncurry2(decoder), path, value)))), (objectArg = get$.Required, objectArg.Field("docs", uncurry2(arg_1)))));
    }, path_1, v));
}

export class View extends Record {
    constructor(Sensor, Probes) {
        super();
        this.Sensor = Sensor;
        this.Probes = Probes;
    }
}

export function View_$reflection() {
    return record_type("Shared.View", [], View, () => [["Sensor", Types_Full_$reflection()], ["Probes", DataListSequence_$reflection()]]);
}

export function View_get_Decoder() {
    return (path) => ((v) => object_1((get$) => {
        let arg_1, objectArg, arg_3, objectArg_1;
        return new View((arg_1 = Types_Full_get_Decoder(), (objectArg = get$.Required, objectArg.Field("sensor", uncurry2(arg_1)))), (arg_3 = DataListSequence_get_Decoder(), (objectArg_1 = get$.Required, objectArg_1.Field("probes", uncurry2(arg_3)))));
    }, path, v));
}

export class GenericDocs$1 extends Record {
    constructor(Docs) {
        super();
        this.Docs = Docs;
    }
}

export function GenericDocs$1_$reflection(gen0) {
    return record_type("Shared.GenericDocs`1", [gen0], GenericDocs$1, () => [["Docs", list_type(gen0)]]);
}

export function GenericDocs$1_Decoder_Z1D7C0D26(decoder) {
    return (path_1) => ((v) => object_1((get$) => {
        let objectArg;
        return new GenericDocs$1((objectArg = get$.Required, objectArg.Field("docs", (path, value) => list_4(decoder, path, value))));
    }, path_1, v));
}

export class Token extends Record {
    constructor(Read, Write) {
        super();
        this.Read = Read;
        this.Write = Write;
    }
}

export function Token_$reflection() {
    return record_type("Shared.Token", [], Token, () => [["Read", string_type], ["Write", string_type]]);
}

export function Token_Encode_5AD25479(o) {
    return Encoder_toPlainJsObj(Encoder_string(new Encoder_FieldCheck(0, []), "write", o.Write, Encoder_string(new Encoder_FieldCheck(0, []), "read", o.Read, Encoder_empty)));
}

export function Token_get_Decoder() {
    return (path_2) => ((v) => object_1((get$) => {
        let objectArg, objectArg_1;
        return new Token((objectArg = get$.Required, objectArg.Field("read", string)), (objectArg_1 = get$.Required, objectArg_1.Field("write", string)));
    }, path_2, v));
}

export class VoiceAlarm extends Record {
    constructor(Id, Rev, Count) {
        super();
        this.Id = Id;
        this.Rev = Rev;
        this.Count = (Count | 0);
    }
}

export function VoiceAlarm_$reflection() {
    return record_type("Shared.VoiceAlarm", [], VoiceAlarm, () => [["Id", string_type], ["Rev", option_type(string_type)], ["Count", int32_type]]);
}

export function VoiceAlarm_Encode_Z44848059(o) {
    return Encoder_toPlainJsObj(Encoder_int(new Encoder_FieldCheck(0, []), "count", o.Count, Encoder_string(new Encoder_FieldCheck(1, []), "_rev", o.Rev, Encoder_string(new Encoder_FieldCheck(0, []), "_id", o.Id, Encoder_empty))));
}

export function VoiceAlarm_EncodeForCouch_Z44848059(o) {
    return toString(0, object([["_id", o.Id], ["_rev", option_24((value_1) => value_1)(o.Rev)], ["count", o.Count]]));
}

export function VoiceAlarm_get_Decoder() {
    return (path_3) => ((v) => object_1((get$) => {
        let objectArg, objectArg_1, objectArg_2;
        return new VoiceAlarm((objectArg = get$.Required, objectArg.Field("_id", string)), defaultArg((objectArg_1 = get$.Optional, objectArg_1.Field("_rev", (path_2, value_2) => option_25(string, path_2, value_2))), undefined), (objectArg_2 = get$.Required, objectArg_2.Field("count", uncurry2(int))));
    }, path_3, v));
}

export class VoiceAlarmQuery extends Record {
    constructor(ModuleId, Uuid, Message, TelIndex, Numbers, StartTime) {
        super();
        this.ModuleId = ModuleId;
        this.Uuid = Uuid;
        this.Message = Message;
        this.TelIndex = (TelIndex | 0);
        this.Numbers = Numbers;
        this.StartTime = StartTime;
    }
}

export function VoiceAlarmQuery_$reflection() {
    return record_type("Shared.VoiceAlarmQuery", [], VoiceAlarmQuery, () => [["ModuleId", string_type], ["Uuid", option_type(string_type)], ["Message", string_type], ["TelIndex", int32_type], ["Numbers", list_type(string_type)], ["StartTime", option_type(class_type("System.DateTime"))]]);
}

export function VoiceAlarmQuery_Encode_Z15305C93(o) {
    return toString(0, object([["moduleId", o.ModuleId], ["uuid", option_24((value_1) => value_1)(o.Uuid)], ["message", o.Message], ["telIndex", o.TelIndex], ["numbers", list_5(map((value_5) => value_5, o.Numbers))], ["startTime", option_24(datetime_1)(o.StartTime)]]));
}

export function VoiceAlarmQuery_get_Decoder() {
    return (path_8) => ((v) => object_1((get$) => {
        let objectArg, objectArg_1, objectArg_2, objectArg_3, objectArg_4, objectArg_5;
        return new VoiceAlarmQuery((objectArg = get$.Required, objectArg.Field("moduleId", string)), defaultArg((objectArg_1 = get$.Optional, objectArg_1.Field("uuid", (path_2, value_2) => option_25(string, path_2, value_2))), undefined), (objectArg_2 = get$.Required, objectArg_2.Field("message", string)), (objectArg_3 = get$.Required, objectArg_3.Field("telIndex", uncurry2(int))), (objectArg_4 = get$.Required, objectArg_4.Field("numbers", (path_5, value_6) => list_4(string, path_5, value_6))), defaultArg((objectArg_5 = get$.Optional, objectArg_5.Field("startTime", (path_7, value_8) => option_25(datetime, path_7, value_8))), undefined));
    }, path_8, v));
}

export class VoiceAlarmStatus extends Record {
    constructor(Uuid, IsComplete, WasMachine) {
        super();
        this.Uuid = Uuid;
        this.IsComplete = IsComplete;
        this.WasMachine = WasMachine;
    }
}

export function VoiceAlarmStatus_$reflection() {
    return record_type("Shared.VoiceAlarmStatus", [], VoiceAlarmStatus, () => [["Uuid", option_type(string_type)], ["IsComplete", bool_type], ["WasMachine", bool_type]]);
}

export function VoiceAlarmStatus_Encode_371D75B3(o) {
    return toString(0, object([["uuid", option_24((value) => value)(o.Uuid)], ["isComplete", o.IsComplete], ["wasMachine", o.WasMachine]]));
}

export function VoiceAlarmStatus_get_Decoder() {
    return (path_4) => ((v) => object_1((get$) => {
        let objectArg, objectArg_1, objectArg_2;
        return new VoiceAlarmStatus(defaultArg((objectArg = get$.Optional, objectArg.Field("uuid", (path_1, value_1) => option_25(string, path_1, value_1))), undefined), (objectArg_1 = get$.Required, objectArg_1.Field("isComplete", bool)), (objectArg_2 = get$.Required, objectArg_2.Field("wasMachine", bool)));
    }, path_4, v));
}

export class Ow_Header extends Record {
    constructor(ForwardedUrl, ForwardedPort, Accept, UserAgent, ClientIp, ForwardedProto, ForwardedPrefix, ForwardedHost, ForwardedFor, Host, AcceptEncoding, CacheControl, IOTPoolAuth, ContentType, RealIp) {
        super();
        this.ForwardedUrl = ForwardedUrl;
        this.ForwardedPort = ForwardedPort;
        this.Accept = Accept;
        this.UserAgent = UserAgent;
        this.ClientIp = ClientIp;
        this.ForwardedProto = ForwardedProto;
        this.ForwardedPrefix = ForwardedPrefix;
        this.ForwardedHost = ForwardedHost;
        this.ForwardedFor = ForwardedFor;
        this.Host = Host;
        this.AcceptEncoding = AcceptEncoding;
        this.CacheControl = CacheControl;
        this.IOTPoolAuth = IOTPoolAuth;
        this.ContentType = ContentType;
        this.RealIp = RealIp;
    }
}

export function Ow_Header_$reflection() {
    return record_type("Shared.Ow.Header", [], Ow_Header, () => [["ForwardedUrl", option_type(string_type)], ["ForwardedPort", option_type(string_type)], ["Accept", option_type(string_type)], ["UserAgent", option_type(string_type)], ["ClientIp", option_type(string_type)], ["ForwardedProto", option_type(string_type)], ["ForwardedPrefix", option_type(string_type)], ["ForwardedHost", option_type(string_type)], ["ForwardedFor", option_type(string_type)], ["Host", option_type(string_type)], ["AcceptEncoding", option_type(string_type)], ["CacheControl", option_type(string_type)], ["IOTPoolAuth", option_type(string_type)], ["ContentType", option_type(string_type)], ["RealIp", option_type(string_type)]]);
}

export function Ow_Header_get_Decoder() {
    return (path_30) => ((v) => object_1((get$) => {
        let objectArg, objectArg_1, objectArg_2, objectArg_3, objectArg_4, objectArg_5, objectArg_6, objectArg_7, objectArg_8, objectArg_9, objectArg_10, objectArg_11, objectArg_12, objectArg_13, objectArg_14;
        return new Ow_Header(defaultArg((objectArg = get$.Optional, objectArg.Field("x-forwarded-url", (path_1, value_1) => option_25(string, path_1, value_1))), undefined), defaultArg((objectArg_1 = get$.Optional, objectArg_1.Field("x-forwarded-port", (path_3, value_4) => option_25(string, path_3, value_4))), undefined), defaultArg((objectArg_2 = get$.Optional, objectArg_2.Field("accept", (path_5, value_7) => option_25(string, path_5, value_7))), undefined), defaultArg((objectArg_3 = get$.Optional, objectArg_3.Field("user-agent", (path_7, value_10) => option_25(string, path_7, value_10))), undefined), defaultArg((objectArg_4 = get$.Optional, objectArg_4.Field("x-client-ip", (path_9, value_13) => option_25(string, path_9, value_13))), undefined), defaultArg((objectArg_5 = get$.Optional, objectArg_5.Field("x-forwarded-proto", (path_11, value_16) => option_25(string, path_11, value_16))), undefined), defaultArg((objectArg_6 = get$.Optional, objectArg_6.Field("x-forwarded-prefix", (path_13, value_19) => option_25(string, path_13, value_19))), undefined), defaultArg((objectArg_7 = get$.Optional, objectArg_7.Field("x-forwarded-host", (path_15, value_22) => option_25(string, path_15, value_22))), undefined), defaultArg((objectArg_8 = get$.Optional, objectArg_8.Field("x-forwarded-for", (path_17, value_25) => option_25(string, path_17, value_25))), undefined), defaultArg((objectArg_9 = get$.Optional, objectArg_9.Field("host", (path_19, value_28) => option_25(string, path_19, value_28))), undefined), defaultArg((objectArg_10 = get$.Optional, objectArg_10.Field("accept-encoding", (path_21, value_31) => option_25(string, path_21, value_31))), undefined), defaultArg((objectArg_11 = get$.Optional, objectArg_11.Field("cache-control", (path_23, value_34) => option_25(string, path_23, value_34))), undefined), defaultArg((objectArg_12 = get$.Optional, objectArg_12.Field("x-iotpool-auth", (path_25, value_37) => option_25(string, path_25, value_37))), undefined), defaultArg((objectArg_13 = get$.Optional, objectArg_13.Field("content-type", (path_27, value_40) => option_25(string, path_27, value_40))), undefined), defaultArg((objectArg_14 = get$.Optional, objectArg_14.Field("x-real-ip", (path_29, value_43) => option_25(string, path_29, value_43))), undefined));
    }, path_30, v));
}

export class Ow_LightRequest extends Record {
    constructor(ModuleId, RawData, Time) {
        super();
        this.ModuleId = ModuleId;
        this.RawData = RawData;
        this.Time = Time;
    }
}

export function Ow_LightRequest_$reflection() {
    return record_type("Shared.Ow.LightRequest", [], Ow_LightRequest, () => [["ModuleId", string_type], ["RawData", string_type], ["Time", string_type]]);
}

export function Ow_LightRequest_get_Decoder() {
    return (path_3) => ((v) => object_1((get$) => {
        let objectArg_1, objectArg_2;
        let Time;
        const objectArg = get$.Required;
        Time = objectArg.Field("time", string);
        return new Ow_LightRequest((objectArg_1 = get$.Required, objectArg_1.Field("id", string)), (objectArg_2 = get$.Required, objectArg_2.Field("data", string)), Time);
    }, path_3, v));
}

export class Ow_IncomingRequest extends Record {
    constructor(ModuleId, RawData, Rssi, Time, Lat, Long, Path, Method, Query, Body, Headers) {
        super();
        this.ModuleId = ModuleId;
        this.RawData = RawData;
        this.Rssi = Rssi;
        this.Time = Time;
        this.Lat = Lat;
        this.Long = Long;
        this.Path = Path;
        this.Method = Method;
        this.Query = Query;
        this.Body = Body;
        this.Headers = Headers;
    }
}

export function Ow_IncomingRequest_$reflection() {
    return record_type("Shared.Ow.IncomingRequest", [], Ow_IncomingRequest, () => [["ModuleId", string_type], ["RawData", string_type], ["Rssi", option_type(string_type)], ["Time", string_type], ["Lat", option_type(float64_type)], ["Long", option_type(float64_type)], ["Path", option_type(string_type)], ["Method", string_type], ["Query", option_type(string_type)], ["Body", option_type(string_type)], ["Headers", option_type(Ow_Header_$reflection())]]);
}

export function Ow_IncomingRequest_get_Decoder() {
    return (path_17) => ((v) => object_1((get$) => {
        let objectArg_1, objectArg_4, objectArg_6, objectArg_7, arg_17, decoder_4, objectArg_8, objectArg_9, objectArg_10;
        let Time;
        const objectArg = get$.Required;
        Time = objectArg.Field("Time", string);
        const Rssi = defaultArg((objectArg_1 = get$.Optional, objectArg_1.Field("rssi", (path_2, value_2) => option_25(string, path_2, value_2))), undefined);
        let ModuleId;
        const objectArg_2 = get$.Required;
        ModuleId = objectArg_2.Field("moduleId", string);
        let RawData;
        const objectArg_3 = get$.Required;
        RawData = objectArg_3.Field("data", string);
        const Path = defaultArg((objectArg_4 = get$.Optional, objectArg_4.Field("__ow_path", (path_6, value_7) => option_25(string, path_6, value_7))), undefined);
        let Method;
        const objectArg_5 = get$.Required;
        Method = objectArg_5.Field("__ow_method", string);
        const Query = defaultArg((objectArg_6 = get$.Optional, objectArg_6.Field("__ow_query", (path_9, value_11) => option_25(string, path_9, value_11))), undefined);
        const Body = defaultArg((objectArg_7 = get$.Optional, objectArg_7.Field("__ow_body", (path_11, value_14) => option_25(string, path_11, value_14))), undefined);
        const Headers = defaultArg((arg_17 = ((decoder_4 = Ow_Header_get_Decoder(), (path_12) => ((value_16) => option_25(uncurry2(decoder_4), path_12, value_16)))), (objectArg_8 = get$.Optional, objectArg_8.Field("__ow_headers", uncurry2(arg_17)))), undefined);
        return new Ow_IncomingRequest(ModuleId, RawData, Rssi, Time, defaultArg((objectArg_9 = get$.Optional, objectArg_9.Field("lat", (path_14, value_19) => option_25(float, path_14, value_19))), undefined), defaultArg((objectArg_10 = get$.Optional, objectArg_10.Field("long", (path_16, value_22) => option_25(float, path_16, value_22))), undefined), Path, Method, Query, Body, Headers);
    }, path_17, v));
}

export class Ow_OpenWhiskParameters extends Record {
    constructor(Path, Method, Query, Body, All) {
        super();
        this.Path = Path;
        this.Method = Method;
        this.Query = Query;
        this.Body = Body;
        this.All = All;
    }
}

export function Ow_OpenWhiskParameters_$reflection() {
    return record_type("Shared.Ow.OpenWhiskParameters", [], Ow_OpenWhiskParameters, () => [["Path", option_type(string_type)], ["Method", string_type], ["Query", option_type(string_type)], ["Body", option_type(string_type)], ["All", obj_type]]);
}

export class Nexmo_Status extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Delivered", "Expired", "Failed", "Rejected", "Accepted", "Buffered", "Unknown"];
    }
}

export function Nexmo_Status_$reflection() {
    return union_type("Shared.Nexmo.Status", [], Nexmo_Status, () => [[], [], [], [], [], [], []]);
}

export function Nexmo_Status_get_Decoder() {
    return (path_1) => ((value_1) => andThen(uncurry3((_arg) => {
        switch (_arg) {
            case "delivered":
                return (arg10$0040) => ((arg20$0040) => succeed(new Nexmo_Status(0, []), arg10$0040, arg20$0040));
            case "expired":
                return (arg10$0040_1) => ((arg20$0040_1) => succeed(new Nexmo_Status(1, []), arg10$0040_1, arg20$0040_1));
            case "failed":
                return (arg10$0040_2) => ((arg20$0040_2) => succeed(new Nexmo_Status(2, []), arg10$0040_2, arg20$0040_2));
            case "rejected":
                return (arg10$0040_3) => ((arg20$0040_3) => succeed(new Nexmo_Status(3, []), arg10$0040_3, arg20$0040_3));
            case "accepted":
                return (arg10$0040_4) => ((arg20$0040_4) => succeed(new Nexmo_Status(4, []), arg10$0040_4, arg20$0040_4));
            case "buffered":
                return (arg10$0040_5) => ((arg20$0040_5) => succeed(new Nexmo_Status(5, []), arg10$0040_5, arg20$0040_5));
            default:
                return (arg10$0040_6) => ((arg20$0040_6) => succeed(new Nexmo_Status(6, []), arg10$0040_6, arg20$0040_6));
        }
    }), string, path_1, value_1));
}

export class Nexmo_Error extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Throttled", "MissingParams", "InvalidParams", "InvalidCredentials", "InternalError", "InvalidMessage", "NumberBarred", "PartnerAccountBarred", "PartnerQuotaExceeded", "MessageTooLong", "CommunicationFailed", "InvalidSignature", "IllegalSender", "InvalidTTL", "FacilityNotAllowed", "InvalidMessageClass", "MissingProtocol", "NonWhiteListed", "MissingMsisdnParam", "InvalidAccountCampaign", "MsisdnOptedOut", "InvalidCampaignShortcode", "InvalidMission", "RestOnly", "Unknown"];
    }
}

export function Nexmo_Error_$reflection() {
    return union_type("Shared.Nexmo.Error", [], Nexmo_Error, () => [[], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []]);
}

export function Nexmo_Error_get_Decoder() {
    return (path) => ((value) => andThen(uncurry3((_arg) => {
        switch (_arg) {
            case 1:
                return (arg10$0040) => ((arg20$0040) => succeed(new Nexmo_Error(0, []), arg10$0040, arg20$0040));
            case 2:
                return (arg10$0040_1) => ((arg20$0040_1) => succeed(new Nexmo_Error(1, []), arg10$0040_1, arg20$0040_1));
            case 3:
                return (arg10$0040_2) => ((arg20$0040_2) => succeed(new Nexmo_Error(2, []), arg10$0040_2, arg20$0040_2));
            case 4:
                return (arg10$0040_3) => ((arg20$0040_3) => succeed(new Nexmo_Error(3, []), arg10$0040_3, arg20$0040_3));
            case 5:
                return (arg10$0040_4) => ((arg20$0040_4) => succeed(new Nexmo_Error(4, []), arg10$0040_4, arg20$0040_4));
            case 6:
                return (arg10$0040_5) => ((arg20$0040_5) => succeed(new Nexmo_Error(5, []), arg10$0040_5, arg20$0040_5));
            case 7:
                return (arg10$0040_6) => ((arg20$0040_6) => succeed(new Nexmo_Error(6, []), arg10$0040_6, arg20$0040_6));
            case 8:
                return (arg10$0040_7) => ((arg20$0040_7) => succeed(new Nexmo_Error(7, []), arg10$0040_7, arg20$0040_7));
            case 9:
                return (arg10$0040_8) => ((arg20$0040_8) => succeed(new Nexmo_Error(8, []), arg10$0040_8, arg20$0040_8));
            case 11:
                return (arg10$0040_9) => ((arg20$0040_9) => succeed(new Nexmo_Error(23, []), arg10$0040_9, arg20$0040_9));
            case 12:
                return (arg10$0040_10) => ((arg20$0040_10) => succeed(new Nexmo_Error(9, []), arg10$0040_10, arg20$0040_10));
            case 13:
                return (arg10$0040_11) => ((arg20$0040_11) => succeed(new Nexmo_Error(10, []), arg10$0040_11, arg20$0040_11));
            case 14:
                return (arg10$0040_12) => ((arg20$0040_12) => succeed(new Nexmo_Error(11, []), arg10$0040_12, arg20$0040_12));
            case 15:
                return (arg10$0040_13) => ((arg20$0040_13) => succeed(new Nexmo_Error(12, []), arg10$0040_13, arg20$0040_13));
            case 16:
                return (arg10$0040_14) => ((arg20$0040_14) => succeed(new Nexmo_Error(13, []), arg10$0040_14, arg20$0040_14));
            case 19:
                return (arg10$0040_15) => ((arg20$0040_15) => succeed(new Nexmo_Error(14, []), arg10$0040_15, arg20$0040_15));
            case 20:
                return (arg10$0040_16) => ((arg20$0040_16) => succeed(new Nexmo_Error(15, []), arg10$0040_16, arg20$0040_16));
            case 23:
                return (arg10$0040_17) => ((arg20$0040_17) => succeed(new Nexmo_Error(16, []), arg10$0040_17, arg20$0040_17));
            case 29:
                return (arg10$0040_18) => ((arg20$0040_18) => succeed(new Nexmo_Error(17, []), arg10$0040_18, arg20$0040_18));
            case 34:
                return (arg10$0040_19) => ((arg20$0040_19) => succeed(new Nexmo_Error(18, []), arg10$0040_19, arg20$0040_19));
            case 101:
                return (arg10$0040_20) => ((arg20$0040_20) => succeed(new Nexmo_Error(19, []), arg10$0040_20, arg20$0040_20));
            case 102:
                return (arg10$0040_21) => ((arg20$0040_21) => succeed(new Nexmo_Error(20, []), arg10$0040_21, arg20$0040_21));
            case 103:
                return (arg10$0040_22) => ((arg20$0040_22) => succeed(new Nexmo_Error(21, []), arg10$0040_22, arg20$0040_22));
            default:
                return (arg10$0040_23) => ((arg20$0040_23) => succeed(new Nexmo_Error(24, []), arg10$0040_23, arg20$0040_23));
        }
    }), uncurry2(int), path, value));
}

export class Nexmo_ErrorMessage extends Record {
    constructor(Status) {
        super();
        this.Status = Status;
    }
}

export function Nexmo_ErrorMessage_$reflection() {
    return record_type("Shared.Nexmo.ErrorMessage", [], Nexmo_ErrorMessage, () => [["Status", Nexmo_Error_$reflection()]]);
}

export function Nexmo_ErrorMessage_get_Decoder() {
    return (path) => ((v) => object_1((get$) => {
        let arg_1, objectArg;
        return new Nexmo_ErrorMessage((arg_1 = Nexmo_Error_get_Decoder(), (objectArg = get$.Required, objectArg.Field("status", uncurry2(arg_1)))));
    }, path, v));
}

export class Nexmo_Errors extends Record {
    constructor(MessageCount, Messages) {
        super();
        this.MessageCount = (MessageCount | 0);
        this.Messages = Messages;
    }
}

export function Nexmo_Errors_$reflection() {
    return record_type("Shared.Nexmo.Errors", [], Nexmo_Errors, () => [["MessageCount", int32_type], ["Messages", list_type(Nexmo_ErrorMessage_$reflection())]]);
}

export function Nexmo_Errors_get_Decoder() {
    return (path_1) => ((v) => object_1((get$) => {
        let objectArg, arg_3, decoder, objectArg_1;
        return new Nexmo_Errors((objectArg = get$.Required, objectArg.Field("message-count", uncurry2(int))), (arg_3 = ((decoder = Nexmo_ErrorMessage_get_Decoder(), (path) => ((value) => list_4(uncurry2(decoder), path, value)))), (objectArg_1 = get$.Required, objectArg_1.Field("messages", uncurry2(arg_3)))));
    }, path_1, v));
}

export class Nexmo_DeliveryReceipt extends Record {
    constructor(Msisdn, To, NetworkCode, MessageId, Price, Status, Scts, Error$) {
        super();
        this.Msisdn = Msisdn;
        this.To = To;
        this.NetworkCode = NetworkCode;
        this.MessageId = MessageId;
        this.Price = Price;
        this.Status = Status;
        this.Scts = Scts;
        this.Error = Error$;
    }
}

export function Nexmo_DeliveryReceipt_$reflection() {
    return record_type("Shared.Nexmo.DeliveryReceipt", [], Nexmo_DeliveryReceipt, () => [["Msisdn", string_type], ["To", string_type], ["NetworkCode", string_type], ["MessageId", string_type], ["Price", float64_type], ["Status", Nexmo_Status_$reflection()], ["Scts", string_type], ["Error", Nexmo_Error_$reflection()]]);
}

export function Nexmo_DeliveryReceipt_get_Decoder() {
    return (path_6) => ((v) => object_1((get$) => {
        let objectArg, objectArg_1, objectArg_2, objectArg_3, objectArg_4, arg_11, objectArg_5, objectArg_6, arg_15, objectArg_7;
        return new Nexmo_DeliveryReceipt((objectArg = get$.Required, objectArg.Field("msisdn", string)), (objectArg_1 = get$.Required, objectArg_1.Field("to", string)), (objectArg_2 = get$.Required, objectArg_2.Field("networkCode", string)), (objectArg_3 = get$.Required, objectArg_3.Field("messageId", string)), (objectArg_4 = get$.Required, objectArg_4.Field("price", float)), (arg_11 = Nexmo_Status_get_Decoder(), (objectArg_5 = get$.Required, objectArg_5.Field("status", uncurry2(arg_11)))), (objectArg_6 = get$.Required, objectArg_6.Field("scts", string)), (arg_15 = Nexmo_Error_get_Decoder(), (objectArg_7 = get$.Required, objectArg_7.Field("err-code", uncurry2(arg_15)))));
    }, path_6, v));
}

export class Nexmo_InboundMessage extends Record {
    constructor(Msisdn, To, MessageId, Text$, Keyword, Timestamp, Nonce, Concat, ConcatRef, ConcatTotal, ConcatPart, Data, Udh) {
        super();
        this.Msisdn = Msisdn;
        this.To = To;
        this.MessageId = MessageId;
        this.Text = Text$;
        this.Keyword = Keyword;
        this.Timestamp = Timestamp;
        this.Nonce = Nonce;
        this.Concat = Concat;
        this.ConcatRef = ConcatRef;
        this.ConcatTotal = ConcatTotal;
        this.ConcatPart = ConcatPart;
        this.Data = Data;
        this.Udh = Udh;
    }
}

export function Nexmo_InboundMessage_$reflection() {
    return record_type("Shared.Nexmo.InboundMessage", [], Nexmo_InboundMessage, () => [["Msisdn", string_type], ["To", string_type], ["MessageId", string_type], ["Text", string_type], ["Keyword", string_type], ["Timestamp", string_type], ["Nonce", string_type], ["Concat", option_type(bool_type)], ["ConcatRef", option_type(int32_type)], ["ConcatTotal", option_type(int32_type)], ["ConcatPart", option_type(int32_type)], ["Data", option_type(string_type)], ["Udh", option_type(string_type)]]);
}

export function Nexmo_InboundMessage_get_Decoder() {
    return (path_16) => ((v) => object_1((get$) => {
        let objectArg, objectArg_1, objectArg_2, objectArg_3, objectArg_4, objectArg_5, objectArg_6, objectArg_7, objectArg_8, objectArg_9, objectArg_10, objectArg_11, objectArg_12;
        return new Nexmo_InboundMessage((objectArg = get$.Required, objectArg.Field("msisdn", string)), (objectArg_1 = get$.Required, objectArg_1.Field("to", string)), (objectArg_2 = get$.Required, objectArg_2.Field("messageId", string)), (objectArg_3 = get$.Required, objectArg_3.Field("text", string)), (objectArg_4 = get$.Required, objectArg_4.Field("keyword", string)), (objectArg_5 = get$.Required, objectArg_5.Field("timestamp", string)), (objectArg_6 = get$.Required, objectArg_6.Field("nonce", string)), defaultArg((objectArg_7 = get$.Optional, objectArg_7.Field("concat", (path_8, value_8) => option_25(bool, path_8, value_8))), undefined), defaultArg((objectArg_8 = get$.Optional, objectArg_8.Field("concat-ref", (path_9, value_10) => option_25(uncurry2(int), path_9, value_10))), undefined), defaultArg((objectArg_9 = get$.Optional, objectArg_9.Field("concat-total", (path_10, value_12) => option_25(uncurry2(int), path_10, value_12))), undefined), defaultArg((objectArg_10 = get$.Optional, objectArg_10.Field("concat-part", (path_11, value_14) => option_25(uncurry2(int), path_11, value_14))), undefined), defaultArg((objectArg_11 = get$.Optional, objectArg_11.Field("data", (path_13, value_17) => option_25(string, path_13, value_17))), undefined), defaultArg((objectArg_12 = get$.Optional, objectArg_12.Field("udh", (path_15, value_20) => option_25(string, path_15, value_20))), undefined));
    }, path_16, v));
}

export class SimpleId extends Record {
    constructor(Id, Rev) {
        super();
        this.Id = Id;
        this.Rev = Rev;
    }
}

export function SimpleId_$reflection() {
    return record_type("Shared.SimpleId", [], SimpleId, () => [["Id", string_type], ["Rev", option_type(string_type)]]);
}

export function SimpleId_get_Decoder() {
    return (path_3) => ((v) => object_1((get$) => {
        let objectArg, objectArg_1;
        return new SimpleId((objectArg = get$.Required, objectArg.Field("_id", string)), defaultArg((objectArg_1 = get$.Optional, objectArg_1.Field("_rev", (path_2, value_2) => option_25(string, path_2, value_2))), undefined));
    }, path_3, v));
}

export class SharedAccess extends Record {
    constructor(Id, Deleted, Rev, Module, Owner, Pass, Code) {
        super();
        this.Id = Id;
        this.Deleted = Deleted;
        this.Rev = Rev;
        this.Module = Module;
        this.Owner = Owner;
        this.Pass = (Pass | 0);
        this.Code = Code;
    }
}

export function SharedAccess_$reflection() {
    return record_type("Shared.SharedAccess", [], SharedAccess, () => [["Id", string_type], ["Deleted", option_type(bool_type)], ["Rev", option_type(string_type)], ["Module", string_type], ["Owner", string_type], ["Pass", int32_type], ["Code", string_type]]);
}

export function SharedAccess_Encode_C5AF2EF(o) {
    return Encoder_toPlainJsObj(Encoder_string(new Encoder_FieldCheck(0, []), "code", o.Code, Encoder_int(new Encoder_FieldCheck(0, []), "pass", o.Pass, Encoder_string(new Encoder_FieldCheck(0, []), "owner", o.Owner, Encoder_string(new Encoder_FieldCheck(0, []), "module", o.Module, Encoder_bool(new Encoder_FieldCheck(1, []), "_deleted", o.Deleted, Encoder_string(new Encoder_FieldCheck(1, []), "_rev", o.Rev, Encoder_string(new Encoder_FieldCheck(0, []), "_id", o.Id, Encoder_empty))))))));
}

export function SharedAccess_Empty(moduleName, owner, code, pass) {
    return new SharedAccess(toText(printf("shared_%s_%s"))(code)(owner), undefined, undefined, moduleName, owner, pass, code);
}

export function SharedAccess_Encoder_C5AF2EF(o) {
    return object([["_id", o.Id], ["_rev", option_24((value_1) => value_1)(o.Rev)], ["_deleted", option_24((value_3) => value_3)(o.Deleted)], ["module", o.Module], ["owner", o.Owner], ["code", o.Code], ["pass", o.Pass]]);
}

export function SharedAccess_get_Decoder() {
    return (path_8) => ((v) => object_1((get$) => {
        let objectArg_1, objectArg_2, objectArg_6;
        let Id;
        const objectArg = get$.Required;
        Id = objectArg.Field("_id", string);
        const Rev_1 = defaultArg((objectArg_1 = get$.Optional, objectArg_1.Field("_rev", (path_2, value_2) => option_25(string, path_2, value_2))), undefined);
        const Deleted = defaultArg((objectArg_2 = get$.Optional, objectArg_2.Field("_deleted", (path_4, value_5) => option_25(bool, path_4, value_5))), undefined);
        let Module;
        const objectArg_3 = get$.Required;
        Module = objectArg_3.Field("module", string);
        let Owner;
        const objectArg_4 = get$.Required;
        Owner = objectArg_4.Field("owner", string);
        let Code;
        const objectArg_5 = get$.Required;
        Code = objectArg_5.Field("code", string);
        return new SharedAccess(Id, Deleted, Rev_1, Module, Owner, (objectArg_6 = get$.Required, objectArg_6.Field("pass", uncurry2(int))), Code);
    }, path_8, v));
}

export class Dummy extends Record {
    constructor(Id, Deleted, Rev, DocKind) {
        super();
        this.Id = Id;
        this.Deleted = Deleted;
        this.Rev = Rev;
        this.DocKind = DocKind;
    }
}

export function Dummy_$reflection() {
    return record_type("Shared.Dummy", [], Dummy, () => [["Id", string_type], ["Deleted", option_type(bool_type)], ["Rev", option_type(string_type)], ["DocKind", Types_DocKind_$reflection()]]);
}

export function Dummy_Encode_59B8C32A(o) {
    return Encoder_toPlainJsObj(Encoder_string(new Encoder_FieldCheck(0, []), "docKind", toString_1(o.DocKind).toUpperCase(), Encoder_bool(new Encoder_FieldCheck(1, []), "_deleted", o.Deleted, Encoder_string(new Encoder_FieldCheck(1, []), "_rev", o.Rev, Encoder_string(new Encoder_FieldCheck(0, []), "_id", o.Id, Encoder_empty)))));
}

export function Dummy_Encoder_59B8C32A(o) {
    return object([["_id", o.Id], ["_rev", option_24((value_1) => value_1)(o.Rev)], ["_deleted", option_24((value_3) => value_3)(o.Deleted)]]);
}

export function Dummy_get_Decoder() {
    return (path_5) => ((v) => object_1((get$) => {
        let objectArg_1, objectArg_2, objectArg_3;
        let Id;
        const objectArg = get$.Required;
        Id = objectArg.Field("_id", string);
        const Rev_1 = defaultArg((objectArg_1 = get$.Optional, objectArg_1.Field("_rev", (path_2, value_2) => option_25(string, path_2, value_2))), undefined);
        return new Dummy(Id, defaultArg((objectArg_2 = get$.Optional, objectArg_2.Field("_deleted", (path_4, value_5) => option_25(bool, path_4, value_5))), undefined), Rev_1, (objectArg_3 = get$.Required, objectArg_3.Field("docKind", uncurry2(Helpers_decodeDocKind))));
    }, path_5, v));
}

